(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-hub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-achub]');
    if (!root) return;

    // --- Sekme gecisi ---
    const tabLinks = [...root.querySelectorAll('[data-tab]')];
    const panels = [...root.querySelectorAll('[data-panel]')];
    const setTab = (name) => {
      const exists = panels.some((p) => p.dataset.panel === name);
      if (!exists) return;
      tabLinks.forEach((l) => l.classList.toggle('is-active', l.dataset.tab === name));
      panels.forEach((p) => p.classList.toggle('is-active', p.dataset.panel === name));
      try { history.replaceState(null, '', '#' + name); } catch (e) {}
    };
    const isMobile = () => window.matchMedia('(max-width: 899px)').matches;
    tabLinks.forEach((l) => l.addEventListener('click', (e) => {
      e.preventDefault();
      setTab(l.dataset.tab);
      if (isMobile()) {
        // Mobil: liste yerine secilen paneli goster (detay gorunumu).
        root.dataset.mv = 'panel';
        window.scrollTo({ top: 0, behavior: 'auto' });
      }
    }));

    // Mobil geri: panelden listeye don.
    const backBtn = root.querySelector('[data-mobile-back]');
    if (backBtn) {
      backBtn.addEventListener('click', () => {
        root.dataset.mv = 'list';
        try { history.replaceState(null, '', location.pathname); } catch (e) {}
        window.scrollTo({ top: 0, behavior: 'auto' });
      });
    }
    // Masaustune gecince liste/panel durumu sifirlanir (masaustu ikisini de gosterir).
    window.matchMedia('(max-width: 899px)').addEventListener('change', (ev) => {
      if (!ev.matches) delete root.dataset.mv;
    });

    const hash = (location.hash || '').replace('#', '');
    if (hash) { setTab(hash); if (isMobile()) root.dataset.mv = 'panel'; }

    // --- Favori sayaci (localStorage: akik_favorites) ---
    const favEls = root.querySelectorAll('[data-fav-count]');
    const readFav = () => { try { return JSON.parse(localStorage.getItem('akik_favorites') || '[]').length; } catch (e) { return 0; } };
    const renderFav = () => {
      const n = readFav();
      favEls.forEach((el) => {
        el.textContent = n;
        // Kenar cubugu rozeti 0'da gizlenir; istatistik sayisi her zaman gorunur.
        if (el.classList.contains('achub__pill')) el.hidden = n === 0;
      });
    };
    renderFav();
    document.addEventListener('akik:fav-change', renderFav);
    window.addEventListener('storage', (e) => { if (e.key === 'akik_favorites') renderFav(); });

    // --- Adres formlari ac/kapat ---
    const esc = (id) => (window.CSS && CSS.escape) ? CSS.escape(id) : id;
    const toggleAddr = (id, show) => {
      const f = root.querySelector('[data-addr-form="' + esc(id) + '"]');
      if (f) f.classList.toggle('acc__hidden', !show);
    };
    root.querySelectorAll('[data-addr-toggle]').forEach((b) => b.addEventListener('click', () => toggleAddr(b.getAttribute('data-addr-toggle'), true)));
    root.querySelectorAll('[data-addr-cancel]').forEach((b) => b.addEventListener('click', () => toggleAddr(b.getAttribute('data-addr-cancel'), false)));

    // --- Bilgilerimi Düzenle modalı ---
    const pModal = root.querySelector('[data-profile-modal]');
    if (pModal) {
      let pTimer = null;
      const openP = () => {
        clearTimeout(pTimer);
        pModal.hidden = false;
        requestAnimationFrame(() => pModal.classList.add('is-open'));
        document.documentElement.style.overflow = 'hidden';
      };
      const closeP = () => {
        pModal.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        pTimer = setTimeout(() => { pModal.hidden = true; }, 260);
      };
      root.querySelectorAll('[data-profile-open]').forEach((b) => b.addEventListener('click', openP));
      pModal.querySelectorAll('[data-profile-close]').forEach((b) => b.addEventListener('click', closeP));
      pModal.addEventListener('click', (e) => { if (e.target === pModal) closeP(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && pModal.classList.contains('is-open')) closeP(); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["akik-havale"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-hv]');
    if (!root) return;
    const API = (root.dataset.api || '').replace(/\/$/, '');
    const CURRENCY = root.dataset.currency || 'TRY';
    const DONE_KEY = 'akik-hv-last-order';
    const $ = (s) => root.querySelector(s);
    const $$ = (s) => root.querySelectorAll(s);

    const stateBox = $('[data-hv-state]');
    const stateText = $('[data-hv-state-text]');
    const stateLink = $('[data-hv-state-link]');
    const main = $('[data-hv-main]');
    const form = $('[data-hv-form]');
    const linesEl = $('[data-hv-lines]');
    const probEl = $('[data-hv-problems]');
    const totalsEl = $('[data-hv-totals]');
    const msgEl = $('[data-hv-msg]');
    const submit = $('[data-hv-submit]');
    const fine = $('[data-hv-fine]');
    const ratesBox = $('[data-hv-rates-box]');
    const ratesEl = $('[data-hv-rates]');
    const doneEl = $('[data-hv-done]');

    // Sunucu tutarlari TL cinsinden (sayi ya da "123.45"). Tema yalnizca bicimler.
    const toNum = (v) => {
      if (v && typeof v === 'object') v = v.amount;
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : 0;
    };
    const money = (v) => {
      const n = toNum(v);
      try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: CURRENCY, maximumFractionDigits: 2 }).format(n); }
      catch (e) { return n.toFixed(2) + ' TL'; }
    };
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const uuid = () => (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
      : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => { const r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16); });

    // API cagrisi: hata durumunda { error } mesajini status ile birlikte firlatir.
    const api = async (path, body) => {
      let res;
      try {
        res = await fetch(API + path, body
          ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }
          : { method: 'GET' });
      } catch (e) {
        const err = new Error('Bağlantı kurulamadı. İnternet bağlantınızı kontrol edip tekrar deneyin.');
        err.status = 0;
        throw err;
      }
      let data = null;
      try { data = await res.json(); } catch (e) { /* bos govde */ }
      if (!res.ok) {
        const err = new Error((data && data.error) || 'Bir hata oluştu. Lütfen tekrar deneyin.');
        err.status = res.status;
        throw err;
      }
      return data || {};
    };

    const showState = (text, { busy = false, link = true } = {}) => {
      main.hidden = true;
      doneEl.hidden = true;
      stateBox.hidden = false;
      stateBox.classList.toggle('is-idle', !busy);
      stateText.textContent = text;
      stateLink.hidden = !link;
    };
    const showMsg = (text) => { msgEl.textContent = text || ''; msgEl.hidden = !text; };

    let config = null;
    let lines = [];
    let quote = null;
    let rateHandle = '';
    let requestId = uuid();
    let quoteSeq = 0;
    let quoting = false;
    let ordering = false;

    const addressBody = () => {
      const f = form.elements;
      const city = f.city.value.trim();
      const district = f.district.value.trim();
      if (!city) return null;
      return { address1: f.address1.value.trim(), district, city, zip: f.zip.value.trim() };
    };

    // ---- Ozet ----
    const renderQuote = () => {
      const q = quote || {};
      const qLines = q.lines || [];
      linesEl.innerHTML = qLines.map((l) => {
        const disc = toNum(l.discountedTotal);
        const full = toNum(l.total);
        const showOld = l.discountedTotal != null && disc < full;
        const vt = l.variantTitle && l.variantTitle !== 'Default Title' ? `<span class="hv__line-var">${esc(l.variantTitle)}</span>` : '';
        return `<li class="hv__line">
          <span class="hv__line-img">${l.image ? `<img src="${esc(l.image)}" alt="" loading="lazy" width="56" height="56">` : ''}<span class="hv__line-qty">${esc(l.quantity)}</span></span>
          <span class="hv__line-name">${esc(l.title)}${vt}</span>
          <span class="hv__line-price">${showOld ? `<s>${money(full)}</s>` : ''}${money(showOld ? disc : full)}</span>
        </li>`;
      }).join('');

      const probs = q.problems || [];
      if (probs.length) {
        probEl.innerHTML = `<p>Sepetinizdeki bazı ürünler için sipariş verilemiyor:</p>
          <ul>${probs.map((p) => `<li><b>${esc(p.title)}</b>: ${esc(p.message)}</li>`).join('')}</ul>
          <a href="{{ routes.cart_url }}">Sepeti düzenle</a>`;
        probEl.hidden = false;
      } else {
        probEl.hidden = true;
        probEl.innerHTML = '';
      }

      let rows = '';
      if (q.productsTotal != null) rows += `<dt>Ürünler</dt><dd>${money(q.productsTotal)}</dd>`;
      (q.discounts || []).forEach((d) => {
        const amt = Math.abs(toNum(d.amount != null ? d.amount : d.value));
        if (!amt) return;
        rows += `<dt class="is-disc">${esc(d.title || d.code || 'İndirim')}</dt><dd class="is-disc">−${money(amt)}</dd>`;
      });
      if (q.shipping) {
        const sp = toNum(q.shipping.price);
        rows += `<dt>${esc(q.shipping.title || 'Kargo')}</dt><dd>${sp ? money(sp) : 'Ücretsiz'}</dd>`;
      } else if (qLines.length) {
        rows += `<dt class="is-muted">Kargo</dt><dd class="is-muted">İl ve ilçe girince hesaplanır</dd>`;
      }
      if (q.total != null && qLines.length) rows += `<dt class="is-total">Ödenecek tutar</dt><dd class="is-total">${money(q.total)}</dd>`;
      totalsEl.innerHTML = rows;

      // Kargo secenekleri: birden fazlaysa secim gosterilir.
      const rates = q.shippingRates || [];
      if (rates.length > 1) {
        const cur = (q.shipping && q.shipping.handle) || rateHandle;
        ratesEl.innerHTML = rates.map((r) => `<label class="hv__rate">
          <input type="radio" name="hv-rate" value="${esc(r.handle)}"${r.handle === cur ? ' checked' : ''}>
          <span>${esc(r.title)}</span><b>${toNum(r.price) ? money(r.price) : 'Ücretsiz'}</b>
        </label>`).join('');
        ratesBox.hidden = false;
      } else {
        ratesBox.hidden = true;
        ratesEl.innerHTML = '';
      }
      if (q.shipping && q.shipping.handle) rateHandle = q.shipping.handle;

      updateSubmit();
    };

    const updateSubmit = () => {
      const q = quote || {};
      let why = '';
      if (!q.lines || !q.lines.length) why = '';
      else if ((q.problems || []).length) why = 'Siparişi verebilmek için sepetinizi düzenleyin.';
      else if (q.belowMinimum) why = `Havale ile ödeme için en az ${money(q.minSubtotal)} tutarında alışveriş gerekir.`;
      else if (!q.shipping) why = 'Kargo ücretinin hesaplanması için il ve ilçe girin.';
      const ok = !!(q.lines && q.lines.length) && !(q.problems || []).length && !q.belowMinimum && !!q.shipping;
      submit.disabled = !ok || quoting || ordering;
      fine.textContent = why;
    };

    // ---- /quote ----
    const runQuote = async () => {
      const seq = ++quoteSeq;
      quoting = true;
      updateSubmit();
      const body = { lines };
      const addr = addressBody();
      if (addr) body.address = addr;
      if (rateHandle) body.shippingRateHandle = rateHandle;
      try {
        const q = await api('/quote', body);
        if (seq !== quoteSeq) return;
        quote = q;
        if (!msgEl.dataset.sticky) showMsg('');
        renderQuote();
      } catch (e) {
        if (seq !== quoteSeq) return;
        if (e.status === 403) { showState(e.message); return; }
        showMsg(e.message);
      } finally {
        if (seq === quoteSeq) { quoting = false; updateSubmit(); }
      }
    };
    let quoteTimer = 0;
    const queueQuote = () => { clearTimeout(quoteTimer); quoteTimer = setTimeout(runQuote, 400); };

    // Il / ilce / posta kodu degisince yeniden hesapla.
    let lastAddrKey = '';
    const onAddr = () => {
      const a = addressBody();
      const key = a ? [a.city, a.district, a.zip].join('|') : '';
      if (key === lastAddrKey) return;
      lastAddrKey = key;
      queueQuote();
    };
    $$('[data-hv-addr]').forEach((el) => {
      el.addEventListener('input', onAddr);
      el.addEventListener('change', onAddr);
    });
    ratesEl.addEventListener('change', (e) => {
      if (e.target.name !== 'hv-rate') return;
      rateHandle = e.target.value;
      runQuote();
    });

    // ---- Dogrulama ----
    const normPhone = (v) => {
      let d = String(v || '').replace(/\D/g, '');
      if (d.length === 12 && d.startsWith('90')) d = d.slice(2);
      else if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
      return d;
    };
    const setFieldError = (input, text) => {
      const field = input.closest('.hv__field');
      if (!field) return;
      let err = field.querySelector('.hv__err');
      field.classList.toggle('is-invalid', !!text);
      if (text) {
        if (!err) { err = document.createElement('span'); err.className = 'hv__err'; field.appendChild(err); }
        err.textContent = text;
      } else if (err) err.remove();
    };
    const validate = () => {
      const f = form.elements;
      let first = null;
      const check = (el, ok, text) => {
        setFieldError(el, ok ? '' : text);
        if (!ok && !first) first = el;
      };
      check(f.firstName, f.firstName.value.trim(), 'Adınızı girin.');
      check(f.lastName, f.lastName.value.trim(), 'Soyadınızı girin.');
      check(f.email, /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email.value.trim()), 'Geçerli bir e-posta girin.');
      check(f.phone, normPhone(f.phone.value).length === 10, '10 haneli telefon numarası girin (ör. 05xx xxx xx xx).');
      check(f.city, f.city.value, 'İl seçin.');
      check(f.district, f.district.value.trim(), 'İlçe girin.');
      check(f.address1, f.address1.value.trim().length >= 5, 'Açık adresinizi girin.');
      if (first) first.focus();
      return !first;
    };
    form.addEventListener('input', (e) => {
      const field = e.target.closest('.hv__field');
      if (field && field.classList.contains('is-invalid')) setFieldError(e.target, '');
    });
    form.addEventListener('submit', (e) => e.preventDefault());

    // ---- /order ----
    submit.addEventListener('click', async () => {
      if (submit.disabled || ordering) return;
      if (!validate()) return;
      const f = form.elements;
      ordering = true;
      submit.classList.add('is-busy');
      submit.textContent = 'Sipariş oluşturuluyor…';
      delete msgEl.dataset.sticky;
      showMsg('');
      updateSubmit();
      const body = {
        requestId,
        lines,
        contact: {
          firstName: f.firstName.value.trim(),
          lastName: f.lastName.value.trim(),
          email: f.email.value.trim(),
          phone: f.phone.value.trim()
        },
        address: addressBody(),
        shippingRateHandle: rateHandle,
        note: f.note.value.trim(),
        website: f.website.value
      };
      try {
        const res = await api('/order', body);
        try { await fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } }); } catch (e) { /* yok say */ }
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = el.classList.contains('mnav__count') ? '0' : '(0)';
          el.setAttribute('data-cart-count', '0');
        });
        try { sessionStorage.setItem(DONE_KEY, JSON.stringify(res)); } catch (e) { /* yok say */ }
        showDone(res);
      } catch (e) {
        // Sunucu kesin cevap verdiyse (4xx) yeni deneme yeni requestId alir; baglanti
        // koptuysa siparis olusmus olabilir -> AYNI requestId ile tekrar denenir.
        if (e.status >= 400 && e.status < 500) requestId = uuid();
        if (e.status === 403) { showState(e.message); return; }
        msgEl.dataset.sticky = '1';
        showMsg(e.message);
        if (e.status === 409) runQuote();
      } finally {
        ordering = false;
        submit.classList.remove('is-busy');
        submit.textContent = 'Siparişi onayla';
        updateSubmit();
      }
    });

    // ---- Onay ekrani ----
    const showDone = (res) => {
      stateBox.hidden = true;
      main.hidden = true;
      doneEl.hidden = false;
      $$('[data-hv-order]').forEach((el) => { el.textContent = res.orderName || ''; });
      $('[data-hv-total]').textContent = money(res.total != null ? res.total : (res.quote && res.quote.total));
      const accs = res.accounts || (config && config.accounts) || [];
      $('[data-hv-accounts]').innerHTML = accs.map((a) => `<li class="hv__acc">
        <span class="hv__acc-bank">${esc(a.bank)}</span>
        <span class="hv__acc-holder">Alıcı: ${esc(a.holder)}</span>
        <span class="hv__acc-iban"><code>${esc(a.iban)}</code><button type="button" class="hv__copy" data-copy="${esc(String(a.iban || '').replace(/\s/g, ''))}">Kopyala</button></span>
      </li>`).join('');
      const instr = $('[data-hv-instr]');
      instr.textContent = res.instructions || '';
      instr.hidden = !res.instructions;
      const days = parseInt(res.autoCancelDays, 10) || 0;
      const cancel = $('[data-hv-cancel]');
      cancel.textContent = days > 0 ? `Ödeme ${days} gün içinde yapılmazsa sipariş iptal edilir.` : '';
      cancel.hidden = days <= 0;
      const st = $('[data-hv-status]');
      if (res.statusUrl) { st.href = res.statusUrl; st.hidden = false; } else st.hidden = true;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    doneEl.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-copy]');
      if (!btn) return;
      const txt = btn.dataset.copy;
      try { await navigator.clipboard.writeText(txt); }
      catch (err) {
        const ta = document.createElement('textarea');
        ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (e2) { /* yok say */ }
        ta.remove();
      }
      btn.textContent = 'Kopyalandı';
      btn.classList.add('is-done');
      setTimeout(() => { btn.textContent = 'Kopyala'; btn.classList.remove('is-done'); }, 2000);
    });

    // ---- Baslangic ----
    (async () => {
      showState('Yükleniyor…', { busy: true, link: false });
      let cart;
      try {
        [config, cart] = await Promise.all([
          api('/config'),
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((r) => r.json())
        ]);
      } catch (e) {
        showState(e.status === 0 ? 'Havale ile ödeme şu an yüklenemedi. Sayfayı yenileyin ya da kartla ödemeye devam edin.' : e.message);
        return;
      }
      if (!config || !config.enabled) {
        showState('Havale ile ödeme şu an kullanılamıyor. Kartla ödemeye devam edebilirsiniz.');
        return;
      }
      if (!cart.items || !cart.items.length) {
        // Siparisten sonra sayfa yenilendiyse onay ekranini yeniden goster.
        let last = null;
        try { last = JSON.parse(sessionStorage.getItem(DONE_KEY) || 'null'); } catch (e) { /* yok say */ }
        if (last && last.orderName) { showDone(last); return; }
        showState('Sepetiniz boş.');
        stateLink.textContent = 'Alışverişe başla';
        stateLink.href = '{{ routes.all_products_collection_url }}';
        return;
      }
      try { sessionStorage.removeItem(DONE_KEY); } catch (e) { /* yok say */ }
      lines = cart.items;
      // Oran panelden gelir (temadaki havale_percent burada kullanilmaz).
      const pct = toNum(config.discountPercent);
      const badge = $('[data-hv-pct]');
      if (pct && badge) { badge.textContent = `%${pct} ${config.discountTitle || 'Havale/EFT indirimi'}`; badge.hidden = false; }
      stateBox.hidden = true;
      main.hidden = false;
      const a = addressBody();
      lastAddrKey = a ? [a.city, a.district, a.zip].join('|') : '';
      await runQuote();
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  document.querySelectorAll('[data-stores-modal]').forEach((modal) => {
    // Tetikleyici ayni section icinde; en yakin section kokunden bulunur.
    const root = modal.closest('.shopify-section') || document;
    const openBtn = root.querySelector('[data-stores-open]');
    if (!openBtn) return;

    let lastFocus = null;

    const open = () => {
      lastFocus = document.activeElement;
      modal.hidden = false;
      requestAnimationFrame(() => modal.classList.add('is-open'));
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';

      // Duyuru bari section'i z-index:49 ile kendi katman baglamini kuruyor;
      // modal onun icinde oldugu icin z-index:200'u o baglamda kaliyor ve
      // header (z-index:50) modalin ustune biniyordu -- kapatma butonu
      // erisilemez oluyordu. Modal acikken section'i header'in ustune cikar.
      if (root.style) root.style.zIndex = '300';

      // Odak modala tasinir: klavye kullanicisi acilan icerikten devam etsin.
      modal.querySelector('[data-stores-close]')?.focus();
    };

    const close = () => {
      modal.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      // Cikis animasyonu bitmeden gizlemek animasyonu yutar; z-index de
      // ancak animasyon bittikten sonra geri alinir ki modal kapanirken
      // header'in altina dusup titremesin.
      const done = () => {
        modal.hidden = true;
        if (root.style) root.style.zIndex = '';
        modal.removeEventListener('transitionend', done);
      };
      modal.addEventListener('transitionend', done);
      // Animasyon kapali olabilir; guvenlik icin kisa bir yedek.
      setTimeout(() => {
        if (modal.classList.contains('is-open') === false) {
          modal.hidden = true;
          if (root.style) root.style.zIndex = '';
        }
      }, 400);
      lastFocus?.focus();
    };

    openBtn.addEventListener('click', open);
    modal.querySelectorAll('[data-stores-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  document.querySelectorAll('[data-copy-link]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const url = btn.getAttribute('data-url');
      const done = () => { btn.classList.add('is-copied'); setTimeout(() => btn.classList.remove('is-copied'), 1500); };
      if (navigator.clipboard) { navigator.clipboard.writeText(url).then(done).catch(() => {}); }
      else { try { const t = document.createElement('textarea'); t.value = url; document.body.appendChild(t); t.select(); document.execCommand('copy'); t.remove(); done(); } catch (e) {} }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-story]').forEach((root) => {
    const steps = [...root.querySelectorAll('[data-story-step]')];
    const visuals = [...root.querySelectorAll('[data-story-visual]')];
    if (steps.length === 0) return;

    // Mobilde gorsel sabitlenmiyor, adimlar zaten hepsi gorunur: gozlemciyi
    // hic kurmuyoruz.
    if (window.matchMedia('(max-width: 989px)').matches) return;

    const show = (index) => {
      steps.forEach((s) => s.classList.toggle('is-active', s.dataset.storyStep === index));
      visuals.forEach((v) => v.classList.toggle('is-active', v.dataset.storyVisual === index));
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) show(entry.target.dataset.storyStep);
        });
      },
      {
        // Ekranin ortasinda ince bir serit: adim tam bu seride girdiginde
        // aktif olur. Boylece hangi adimin "su an okundugu" net olur ve iki
        // adim ayni anda aktif gorunmez.
        rootMargin: '-45% 0px -45% 0px',
        threshold: 0,
      }
    );

    steps.forEach((step) => observer.observe(step));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  // Slider ilerleme cizgisini kaydirma konumuna gore surer (ana sayfa carousel'i gibi).
  const initRecSlider = (el) => {
    const track = el.querySelector('.related__grid');
    const bar = el.querySelector('[data-rec-bar]');
    if (!track || !bar) return;
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 1) { bar.style.width = '100%'; bar.style.transform = 'none'; return; }
      const visible = track.clientWidth / track.scrollWidth;
      bar.style.width = `${visible * 100}%`;
      bar.style.transform = `translateX(${(track.scrollLeft / max) * ((1 / visible) - 1) * 100}%)`;
    };
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  };

  document.querySelectorAll('[data-cart-rec]').forEach((el) => {
    const url = el.dataset.url;
    if (!url || url.indexOf('product_id=&') !== -1 || url.endsWith('product_id=')) return;
    if (el.querySelector('.related__inner')) { initRecSlider(el); return; }
    fetch(url)
      .then((r) => r.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const fresh = doc.querySelector('.related__inner');
        if (fresh) { el.innerHTML = fresh.outerHTML; initRecSlider(el); }
      })
      .catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart]').forEach((root) => {
    const CURRENCY = root.dataset.currency || 'TRY';
    // Magazanin para bicimi (Liquid | money ile ayni: "5,750.00TL"); bicim yoksa tr-TR.
    const MONEY_FMT = root.dataset.moneyFormat || '';
    const money = (c) => {
      const m = MONEY_FMT.match(/\{\{\s*(\w+)\s*\}\}/);
      if (m) {
        const n = (c || 0) / 100;
        const grp = (v, t, d, dec) => { const [i, f] = v.toFixed(dec).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? d + f : ''); };
        const out = { amount: grp(n, ',', '.', 2), amount_no_decimals: grp(n, ',', '.', 0), amount_with_comma_separator: grp(n, '.', ',', 2), amount_no_decimals_with_comma_separator: grp(n, '.', ',', 0) }[m[1]];
        if (out !== undefined) return MONEY_FMT.replace(m[0], out);
      }
      try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: CURRENCY, maximumFractionDigits: 2 }).format(c / 100); }
      catch (e) { return (c / 100).toFixed(2); }
    };

    // Havale/EFT butonu: Akik Pazar /config acik derse gorunur, oran oradan.
    // 60 sn sessionStorage onbellek (sunucu da 60 sn onbellekli).
    const havaleCtas = root.querySelectorAll('[data-havale-cta]');
    if (havaleCtas.length) {
      const HV_KEY = 'akik-hv-config';
      const applyHv = (cfg) => {
        if (!cfg || !cfg.enabled) return;
        const pct = parseFloat(cfg.discountPercent) || 0;
        havaleCtas.forEach((el) => {
          el.dataset.havalePct = pct;
          el.dataset.havaleMin = parseFloat(cfg.minSubtotal) || 0;
          el.dataset.havaleOn = '1';
          el.querySelectorAll('[data-havale-pctlabel]').forEach((p) => { p.textContent = '%' + pct; });
        });
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((r) => r.json()).then(updateSummary).catch(() => {});
      };
      let cached = null;
      try {
        const c = JSON.parse(sessionStorage.getItem(HV_KEY) || 'null');
        if (c && Date.now() - c.t < 60000) cached = c.v;
      } catch (e) { /* yok say */ }
      if (cached) setTimeout(() => applyHv(cached), 0);
      else {
        fetch('https://akikpazar.qubite.net/api/bank-transfer/public/config')
          .then((r) => (r.ok ? r.json() : null))
          .then((cfg) => {
            try { sessionStorage.setItem(HV_KEY, JSON.stringify({ t: Date.now(), v: cfg })); } catch (e) { /* yok say */ }
            applyHv(cfg);
          })
          .catch(() => {});
      }
    }

    const SID = root.dataset.sectionId;
    const countEls = document.querySelectorAll('[data-cart-count]');
    // Baslik "(3)" yazar; header/alt menu rozetleri sayi + data-cart-count (0 iken CSS gizler).
    const setCount = (n) => countEls.forEach((el) => {
      const v = el.getAttribute('data-cart-count');
      if (v !== null && v !== '') { el.textContent = n; el.setAttribute('data-cart-count', n); }
      else el.textContent = `(${n})`;
    });
    // Ilave harf ucreti satirlari ana urunun alt kalemi -> sayimda haric.
    const realCount = (cart) => (cart.items || []).reduce((s, i) => (((i.handle || '').indexOf('harf-ucreti') !== -1) ? s : s + i.quantity), 0);

    const post = (url, body) =>
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then((r) => r.json());

    const updateSummary = (cart) => {
      let listTotal = 0;
      root.querySelectorAll('.citem').forEach((li) => {
        const unit = parseInt(li.dataset.unitList, 10) || 0;
        const q = parseInt(li.querySelector('[data-qty-val]')?.textContent, 10) || 0;
        listTotal += unit * q;
        // Ana urune gomulu ilave harf ucreti de toplama dahil.
        listTotal += parseInt(li.dataset.feeTotal, 10) || 0;
      });
      const payable = cart.total_price;
      const disc = Math.max(0, listTotal - payable);
      const pct = (listTotal > 0 && disc > 0) ? Math.round(disc * 100 / listTotal) : 0;
      // Ozet panel + mobil sabit cubuk ayni data-attribute'lari paylasir;
      // querySelectorAll ile ikisini de guncelliyoruz.
      root.querySelectorAll('[data-sum-total]').forEach((el) => { el.textContent = money(listTotal); });
      root.querySelectorAll('[data-sum-payable]').forEach((el) => { el.textContent = money(payable); });
      // Havale/EFT indirimli tutari guncelle (odenecek uzerinden).
      root.querySelectorAll('[data-havale]').forEach((el) => {
        const hp = parseFloat(el.dataset.havalePct) || 0;
        const out = el.querySelector('[data-havale-price]');
        const hvTotal = Math.round(payable * (100 - hp) / 100);
        if (out) out.textContent = money(hvTotal);
        // Ucretsiz kargo: Shopify esigi INDIRIMLI tutara bakar (sunucu /quote ile ayni).
        const ship = el.querySelector('[data-havale-ship]');
        const fs = parseInt(el.dataset.havaleFreeship, 10) || 0;
        if (ship && fs) ship.textContent = hvTotal >= fs ? '· Kargo ücretsiz' : '+ kargo';
        // Sunucunun alt limiti (TL) altindaysa buton gizlenir.
        if (el.dataset.havaleOn) el.hidden = payable / 100 < (parseFloat(el.dataset.havaleMin) || 0);
      });
      root.querySelectorAll('[data-sum-discount]').forEach((el) => { el.textContent = '-' + money(disc) + ' (%' + pct + ')'; });
      root.querySelectorAll('[data-sum-discount-row]').forEach((el) => { el.hidden = disc <= 0; });
      root.querySelectorAll('[data-sheet-count]').forEach((el) => { el.textContent = realCount(cart); });
      // Ucretsiz kargo ilerlemesi (adet degisince guncelle).
      root.querySelectorAll('[data-ship]').forEach((el) => {
        const thr = parseInt(el.dataset.shipThreshold, 10) || 0;
        if (!thr) return;
        const remaining = thr - payable;
        const p = Math.min(100, Math.round(payable * 100 / thr));
        const fill = el.querySelector('[data-ship-fill]');
        const txt = el.querySelector('[data-ship-text]');
        if (fill) fill.style.inlineSize = p + '%';
        if (remaining <= 0) {
          // Esik gecildi -> cubuk gizlenir (kargo zaten ucretsiz).
          el.classList.add('cart__ship--reached');
        } else {
          el.classList.remove('cart__ship--reached');
          if (txt) txt.innerHTML = 'Sepete <b>' + money(remaining) + '</b> daha ekle, <b>ücretsiz kargo</b> kazan';
        }
      });
      // Sheet acikken icerik degisirse yuksekligi guncelle.
      const _sh = root.querySelector('[data-cart-sheet]');
      const _p = _sh && _sh.querySelector('[data-sheet-body]');
      if (_sh && _p && _sh.classList.contains('is-open')) _p.style.maxBlockSize = _p.scrollHeight + 'px';
    };

    // Kapat (X): once kapanis animasyonu, sonra geri git / ana sayfa.
    root.querySelectorAll('[data-cart-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        var go = function () {
          var sameOriginRef = document.referrer && document.referrer.indexOf(window.location.origin) === 0;
          if (window.history.length > 1 && sameOriginRef) window.history.back();
          else window.location.href = '/';
        };
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var mobile = window.matchMedia('(max-width: 989px)').matches;
        if (reduce || !mobile) { go(); return; }
        var done = false;
        var fire = function () { if (done) return; done = true; go(); };
        root.classList.add('is-closing');
        var inner = root.querySelector('.cart__inner');
        (inner || root).addEventListener('animationend', fire, { once: true });
        setTimeout(fire, 450); // yedek
      });
    });

    // Sabit alt panel (ozet + indirim kodu): yuksekligini olcup --cart-sheet-h'ye
    // yaz. Boylece urun listesi (cart__inner padding-bottom) panelin arkasinda
    // kalmaz; urunler panelin ustunde rahatca kayar.
    const sheet = root.querySelector('[data-cart-sheet]');
    if (sheet) {
      var syncSheetH = function () {
        root.style.setProperty('--cart-sheet-h', sheet.offsetHeight + 'px');
      };
      syncSheetH();
      window.addEventListener('resize', syncSheetH);
      if ('ResizeObserver' in window) { new ResizeObserver(syncSheetH).observe(sheet); }
      // Not alani acilip kapaninca da yeniden olc.
      root.querySelectorAll('[data-notes-toggle]').forEach(function (b) {
        b.addEventListener('click', function () { setTimeout(syncSheetH, 0); });
      });
    }

    // --- Ekstra secenekler (kapali linkler): indirim kodu / not ac-kapat ---
    var toggleBox = function (btn, sel) {
      // Butonun en yakin kapsayicisindaki (web ozet kutusu / mobil sheet) kutuyu bul;
      // yoksa global ilk. Boylece web ve mobil not/promo bagimsiz calisir.
      var scope = btn.closest('.cart__ordersum') || btn.closest('.cart__sheet-foot') || root;
      var box = scope.querySelector(sel) || root.querySelector(sel);
      if (!box) return;
      var open = box.hasAttribute('hidden');
      if (open) { box.removeAttribute('hidden'); (box.querySelector('input,textarea'))?.focus(); }
      else box.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (typeof syncSheetH === 'function') setTimeout(syncSheetH, 0);
    };
    root.querySelectorAll('[data-notes-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () { toggleBox(btn, '[data-notes]'); });
    });
    root.querySelectorAll('[data-promo-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () { toggleBox(btn, '[data-promo]'); });
    });
    // Hediye paketi secimini ANINDA kaydet (checkout beklemeden sepete islensin).
    root.querySelectorAll('[data-gift]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        post('/cart/update.js', { attributes: { 'Hediye Paketi': cb.checked ? 'Evet' : '' } });
      });
    });
    // Notu yazi bitince kaydet (web ozet + mobil panel; ikisi de).
    root.querySelectorAll('[data-notes] textarea').forEach(function (noteField) {
      noteField.addEventListener('change', function () {
        post('/cart/update.js', { note: noteField.value });
        root.querySelectorAll('[data-notes] textarea').forEach(function (t) { if (t !== noteField) t.value = noteField.value; });
        var d = root.querySelector('[data-mdot="note"]');
        if (d) d.hidden = !noteField.value.trim();
      });
    });

    // --- Mobil ikonlar: Hediye Notu / Hediye Paketi / Indirim Kodu ---
    // Ikona basinca altindaki panel acilir; ayni anda tek panel acik.
    root.querySelectorAll('[data-mtools]').forEach(function (tools) {
      var tabs = tools.querySelectorAll('[data-mtab]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.dataset.mtab;
          var willOpen = tab.getAttribute('aria-expanded') !== 'true';
          tabs.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
          tools.querySelectorAll('[data-mpanel]').forEach(function (p) { p.hidden = true; });
          if (willOpen) {
            tab.setAttribute('aria-expanded', 'true');
            var panel = tools.querySelector('[data-mpanel="' + key + '"]');
            // Klavye hemen ACILMAZ: alan gorunur, kullanici alana dokununca acilir.
            if (panel) panel.hidden = false;
          }
          if (typeof syncSheetH === 'function') setTimeout(syncSheetH, 0);
        });
      });

      // Klavye acilinca (iOS/Android) alttaki sabit paneli klavyenin USTUNE kaldir:
      // aksi halde acilan not/kod alani klavyenin arkasinda kalir.
      var vv = window.visualViewport;
      var sheetEl = tools.closest('[data-cart-sheet]');
      if (vv && sheetEl) {
        var lift = function () {
          var kb = window.innerHeight - (vv.offsetTop + vv.height);
          var active = sheetEl.contains(document.activeElement) && kb > 60;
          sheetEl.style.transform = active ? 'translateY(' + (-Math.round(kb)) + 'px)' : '';
        };
        vv.addEventListener('resize', lift);
        vv.addEventListener('scroll', lift);
        sheetEl.addEventListener('focusin', function () { setTimeout(lift, 50); setTimeout(lift, 350); });
        sheetEl.addEventListener('focusout', function () { setTimeout(lift, 50); });
      }
    });

    // 'Ilave harf ucreti' satiri mi?
    const isFeeItem = (i) => (('' + (i.handle || '')).indexOf('harf-ucreti') !== -1);
    // Parent'i (ait oldugu ana urun) sepette OLMAYAN fee satirlarini bul ve sil.
    // Boylece ozel harfli urun silinince ona bagli fee de otomatik gider ->
    // sepet gercekten bosalir (gizli fee kalmaz).
    const cleanOrphanFees = (cart) => {
      var parents = {};
      (cart.items || []).forEach(function (i) { if (!isFeeItem(i)) parents[i.key] = true; });
      var orphans = (cart.items || []).filter(function (i) {
        return isFeeItem(i) && !parents[(i.properties && i.properties._pid) || ''];
      });
      if (!orphans.length) return Promise.resolve(null);
      return Promise.all(orphans.map(function (o) {
        return post('/cart/change.js', { id: o.key, quantity: 0 }).catch(function () {});
      })).then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); });
    };

    // Ana urun silinince ona bagli 'ilave harf ucreti' satirlarini da sil.
    const removeChildFees = (feeKeys) => {
      const keys = (feeKeys || '').split(',').map((k) => k.trim()).filter(Boolean);
      if (!keys.length) return Promise.resolve();
      return Promise.all(keys.map((k) => post('/cart/change.js', { id: k, quantity: 0 }).catch(() => {})));
    };

    // Sepeti yeniden bas (Section Rendering API): satir listesi, kampanya iletileri ve kod cipleri
    // [data-cart-swap] kapsayicilarindan degisir; toplamlar updateSummary ile. Bir kampanya indirimi
    // baska satira tasinabildigi icin (bedava urun degisir) yalnizca degisen satir yetmez.
    const swapSections = (html) => {
      if (!html) return false;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      let ok = true;
      root.querySelectorAll('[data-cart-swap]').forEach((el) => {
        const fresh = doc.querySelector('[data-cart-swap="' + el.dataset.cartSwap + '"]');
        if (fresh) el.replaceWith(document.importNode(fresh, true));
        else ok = false;
      });
      return ok;
    };
    const render = (cart, html) => {
      if (!cart || cart.item_count === 0 || !swapSections(html)) { window.location.reload(); return; }
      setCount(realCount(cart));
      updateSummary(cart);
    };
    const refresh = () => Promise.all([
      fetch('/cart?section_id=' + encodeURIComponent(SID)).then((r) => r.text()),
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((r) => r.json())
    ]).then(([html, cart]) => render(cart, html));
    // Ust uste tiklamalar sirayla islenir (yarisan istekler eski sepeti basmasin).
    let queue = Promise.resolve();
    const enqueue = (fn) => (queue = queue.then(fn).catch(() => {}));
    const withSections = (body) => Object.assign(body, { sections: SID, sections_url: '/cart' });

    const changeLine = (li, quantity) => enqueue(() => {
      const key = li.dataset.key;
      const feeKeys = li.dataset.feeKeys;
      li.style.opacity = '0.5';
      return post('/cart/change.js', withSections({ id: key, quantity }))
        .then((cart) => {
          if (!cart || !cart.items) throw cart;
          const gone = quantity === 0 || !cart.items.some((i) => i.key === key);
          // Ana urunle birlikte ona bagli ilave harf ucretleri de silinir.
          if (gone && feeKeys) return removeChildFees(feeKeys).then(refresh);
          return cleanOrphanFees(cart).then((fresh) => (fresh ? refresh() : render(cart, cart.sections && cart.sections[SID])));
        })
        .catch(() => { li.style.opacity = ''; });
    });

    // Satir dugmeleri olay devretmeyle: yenilenen satirlarda da calisir.
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-inc], [data-qty-dec], [data-line-remove], [data-line-trash]');
      const li = btn && btn.closest('.citem');
      if (!li || !root.contains(li)) return;
      const val = parseInt(li.querySelector('[data-qty-val]')?.textContent, 10) || 1;
      if (btn.matches('[data-qty-inc]')) changeLine(li, val + 1);
      // Azalt: 1'in altina inince urunu kaldirir (0).
      else if (btn.matches('[data-qty-dec]')) changeLine(li, Math.max(0, val - 1));
      else if (btn.matches('[data-line-remove]')) changeLine(li, 0);
      // Cop ikonu: kaldirma onay modalini ac.
      else openConfirm(li);
    });
    // Urun bazinda hediye paketi (line item property).
    root.addEventListener('change', (e) => {
      const cb = e.target.closest('[data-line-gift]');
      const li = cb && cb.closest('.citem');
      if (!li) return;
      const qty = parseInt(li.querySelector('[data-qty-val]')?.textContent, 10) || 1;
      const props = cb.checked ? { 'Hediye Paketi': 'Evet' } : {};
      li.style.opacity = '0.5';
      enqueue(() => post('/cart/change.js', withSections({ id: li.dataset.key, quantity: qty, properties: props }))
        .then((cart) => render(cart, cart.sections && cart.sections[SID]))
        .catch(() => { li.style.opacity = ''; cb.checked = !cb.checked; }));
    });

    // --- Kaldirma onay modali: Favorilere Ekle veya Sil ---
    const confirmEl = root.querySelector('[data-cart-confirm]');
    let confirmLi = null;
    const FAV_KEY = 'akik_favorites';
    const favAdd = (li) => {
      let list;
      try { list = JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch (e) { list = []; }
      const id = li.dataset.favId;
      if (id && !list.some((x) => String(x.id) === String(id))) {
        list.push({
          id: id,
          handle: li.dataset.favHandle,
          title: li.dataset.favTitle,
          url: li.dataset.favUrl,
          image: li.dataset.favImage,
          price: li.dataset.favPrice
        });
        try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {}
        document.dispatchEvent(new CustomEvent('akik:fav-change', { detail: { count: list.length, list: list } }));
      }
    };
    const openConfirm = (li) => {
      if (!confirmEl) { changeLine(li, 0); return; }
      confirmLi = li;
      const nm = confirmEl.querySelector('[data-confirm-name]');
      if (nm) nm.textContent = li.dataset.favTitle || 'Bu ürün';
      confirmEl.hidden = false;
      document.body.style.overflow = 'hidden';
    };
    const closeConfirm = () => {
      if (!confirmEl) return;
      confirmEl.hidden = true;
      confirmLi = null;
      document.body.style.overflow = '';
    };
    confirmEl?.querySelectorAll('[data-confirm-cancel]').forEach((el) => el.addEventListener('click', closeConfirm));
    confirmEl?.querySelector('[data-confirm-del]')?.addEventListener('click', () => {
      const li = confirmLi; closeConfirm(); if (li) changeLine(li, 0);
    });
    confirmEl?.querySelector('[data-confirm-fav]')?.addEventListener('click', () => {
      const li = confirmLi; if (li) favAdd(li); closeConfirm(); if (li) changeLine(li, 0);
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && confirmEl && !confirmEl.hidden) closeConfirm(); });

    root.querySelector('[data-cart-share]')?.addEventListener('click', async () => {
      const url = window.location.origin + '/cart';
      if (navigator.share) { try { await navigator.share({ title: document.title, url }); } catch (e) {} }
      else { try { await navigator.clipboard.writeText(url); } catch (e) {} }
    });

    // Indirim kodu: sag accordion (mobil) + alt cubuk (web) -> ikisini de bagla.
    root.querySelectorAll('[data-discount]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const code = e.target.querySelector('input[name="discount"]').value.trim();
        if (code) window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/cart`;
      });
    });

    // Kupon cipindeki carpi: uygulanan indirim kodunu kaldir.
    // Kod, /discount/CODE ile uygulanirken 'discount_code' cookie'sinde saklanir
    // (httpOnly degil; /cart bunu yeniden set etmez). Cookie'yi kesin sil (expires
    // GECMIS + Max-Age), best-effort AJAX ile de temizleyip sepeti yenile.
    const killCookie = (name) => {
      const past = 'Thu, 01 Jan 1970 00:00:00 GMT';
      const variants = [
        'path=/',
        'path=/; SameSite=Lax',
        'path=/; domain=' + location.hostname,
        'path=/; domain=.' + location.hostname,
        '', // path'siz (mevcut yol)
      ];
      variants.forEach((v) => {
        document.cookie = name + '=; expires=' + past + '; Max-Age=0' + (v ? '; ' + v : '');
      });
    };
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-remove-discount]');
      if (!btn) return;
      {
        btn.disabled = true;
        killCookie('discount_code');
        // Sepete islenmis olabilecek indirimi de temizlemeyi dene (destekleyen magazalar).
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount_codes: [] }),
        }).catch(() => {}).finally(() => {
          // Cache'siz taze /cart.
          window.location.href = '/cart?_=' + Date.now();
        });
      }
    });

    // Kutu oner (upsell): tek tikla sepete ekle, sonra yenile.
    root.querySelectorAll('[data-upsell-add]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-variant-id');
        if (!id) return;
        const txt = btn.querySelector('.cupsell__add-txt');
        btn.disabled = true;
        if (txt) txt.textContent = 'Ekleniyor…';
        enqueue(() => post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
          .then((res) => {
            if (!res || !res.items) throw res;
            btn.classList.add('is-added');
            if (txt) txt.textContent = 'Eklendi ✓';
            return refresh();
          })
          .then(() => { setTimeout(() => { btn.disabled = false; btn.classList.remove('is-added'); if (txt) txt.textContent = 'Sepete Ekle'; }, 1500); })
          .catch(() => { btn.disabled = false; if (txt) txt.textContent = 'Sepete Ekle'; }));
      });
    });

    // Kutu oner: masaustunde varsayilan ACIK, mobilde kapali (alan dar).
    root.querySelectorAll('.cupsell__box').forEach((box) => {
      if (window.matchMedia('(min-width: 990px)').matches) box.open = true;
    });

    // Kutu oner slider'i: oklar + noktalar. Aktif slayt scroll konumundan bulunur.
    root.querySelectorAll('[data-upsell-slider]').forEach((sl) => {
      const track = sl.querySelector('[data-upsell-track]');
      const dots = Array.from(sl.querySelectorAll('.cupsell__dot'));
      const items = Array.from(sl.querySelectorAll('.cupsell__item'));
      if (!track || items.length < 2) return;

      const activeIndex = () => Math.round(track.scrollLeft / track.clientWidth);
      const goTo = (i) => {
        const n = Math.max(0, Math.min(items.length - 1, i));
        track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
      };
      const sync = () => {
        const i = activeIndex();
        dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      };

      sl.querySelector('[data-upsell-prev]')?.addEventListener('click', () => goTo(activeIndex() - 1));
      sl.querySelector('[data-upsell-next]')?.addEventListener('click', () => goTo(activeIndex() + 1));
      dots.forEach((d, idx) => d.addEventListener('click', () => goTo(idx)));
      let raf;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chat-widget"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-chatw]').forEach((root) => {
    const panel = root.querySelector('[data-chatw-panel]');
    const overlay = root.querySelector('[data-chatw-overlay]');
    const body = root.querySelector('[data-chatw-body]');
    const thread = root.querySelector('[data-chatw-thread]');
    const intro = root.querySelector('[data-chatw-intro]');
    if (!panel || !thread || !intro) return;

    const now = () => new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });

    const scrollDown = () => { body.scrollTop = body.scrollHeight; };

    const renderIntro = () => {
      thread.innerHTML = '';
      const node = intro.content.cloneNode(true);
      const t = node.querySelector('[data-chatw-time]');
      if (t) t.textContent = now();
      thread.appendChild(node);
    };

    const addMsg = (text, who) => {
      const wrap = document.createElement('div');
      wrap.className = 'chatw__msg chatw__msg--' + who;
      const bubble = document.createElement('div');
      bubble.className = 'chatw__bubble';
      bubble.textContent = text;
      const time = document.createElement('time');
      time.className = 'chatw__time';
      time.textContent = now();
      bubble.appendChild(time);
      wrap.appendChild(bubble);
      thread.appendChild(wrap);
      scrollDown();
      return wrap;
    };

    const open = () => {
      if (!thread.children.length) renderIntro();
      overlay.hidden = false;
      panel.hidden = false;
      scrollDown();
    };
    const close = () => { panel.hidden = true; overlay.hidden = true; };

    root.querySelectorAll('[data-chatw-open]').forEach((b) => b.addEventListener('click', open));
    root.querySelectorAll('[data-chatw-close]').forEach((b) => b.addEventListener('click', close));

    // Yuzen buton en ustte gizli; asagi scroll'da belirir.
    const launcher = root.querySelector('.chatw__launcher');
    if (launcher) {
      const onScroll = () => {
        const past = window.scrollY > Math.min(400, window.innerHeight * 0.6);
        launcher.classList.toggle('is-visible', past);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) close(); });

    // Baska bolumlerden (urun store-modal, sayfa yardim) acilma olayi.
    // Akik Bot (guncel destek, #akik-bot) sayfadaysa bu olayi O acar; eski pencere
    // acilmaz. Bot kapali/yuklenemediyse yedek olarak bu pencere acilir.
    window.addEventListener('akik:open-chat', () => {
      if (window.__akikBot || document.getElementById('akik-bot')) return;
      open();
    });

    // Soru tiklama: kullanici balonu + placeholder bot cevabi.
    thread.addEventListener('click', (e) => {
      const q = e.target.closest('.chatw__q');
      if (!q) return;
      const answer = q.getAttribute('data-a') || '';
      addMsg(q.textContent.trim(), 'user');
      // Soru listesini gizle (secim yapildi).
      const qs = q.closest('.chatw__qs');
      if (qs) qs.remove();
      setTimeout(() => { if (answer) addMsg(answer, 'bot'); }, 350);
    });

    // Yeni konusma: bastan basla.
    root.querySelectorAll('[data-chatw-new]').forEach((b) =>
      b.addEventListener('click', () => { renderIntro(); scrollDown(); })
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinematic-chapter"] && !Shopify.designMode) return;
  try {
    
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.chapter video.chapter__media-el, .chapter .chapter__media-el video').forEach((v) => {
      v.autoplay = false; v.pause?.();
    });
  }

  document.querySelectorAll('[data-chapter]').forEach((chapter) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { chapter.classList.add('is-in'); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        chapter.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -20% 0px', threshold: 0 });
    io.observe(chapter);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinematic-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cgal]').forEach((root) => {
    const cards = [...root.querySelectorAll('.cgal__card')];
    if (!cards.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.classList.add('cgal--reveal');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
    cards.forEach((c) => io.observe(c));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinematic-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-film-frame]').forEach((frame) => {
    const video = frame.querySelector('video');

    // IntersectionObserver yoksa: kareyi hemen goster ve varsa videoyu oynat.
    if (!('IntersectionObserver' in window)) {
      frame.classList.add('is-inview');
      video?.play?.().catch(() => {});
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Sinematik acilis: bir kez tetiklenir, geri alinmaz.
          frame.classList.add('is-inview');
          // Yalnizca ekranda gorununce oynat; disari cikinca durdur.
          video?.play?.().catch(() => {});
        } else {
          video?.pause?.();
        }
      });
    }, { threshold: 0.25 });

    io.observe(frame);
  });

  // Video ustu 3 SABIT urun karti: kartlar yerinde durur, icindeki urun otomatik
  // degisir (fade). Her turda gorunur kartlarin urunu bir sonrakiyle degisir.
  document.querySelectorAll('[data-fcards]').forEach((box) => {
    const dataEl = box.querySelector('[data-fcards-data]');
    const slots = Array.from(box.querySelectorAll('.film__scard[data-slot]'));
    if (!dataEl || slots.length === 0) return;

    let items = [];
    try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (items.length <= slots.length) return; // donecek fazla urun yoksa sabit kalir

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let offset = 0, paused = false;

    const fill = (slot, it) => {
      slot.href = it.u || '#';
      const img = slot.querySelector('.film__scard-img');
      if (img && it.i) { img.src = it.i; img.srcset = ''; img.alt = it.t || ''; }
      const nm = slot.querySelector('.film__scard-name');
      const pr = slot.querySelector('.film__scard-price');
      if (nm) nm.textContent = it.t || '';
      if (pr) pr.textContent = it.p || '';
    };

    const advance = () => {
      if (paused) return;
      offset = (offset + 1) % items.length;
      // Once fade-out, sonra icerik degis, sonra fade-in.
      slots.forEach((s) => s.classList.add('is-swapping'));
      setTimeout(() => {
        slots.forEach((s, i) => fill(s, items[(offset + i) % items.length]));
        slots.forEach((s) => s.classList.remove('is-swapping'));
      }, 260);
    };
    let timer = setInterval(advance, 3200);

    // Uzerine gelince durakla (okunabilsin / tiklanabilsin).
    box.addEventListener('mouseenter', () => { paused = true; });
    box.addEventListener('mouseleave', () => { paused = false; });
    // Ekran disindayken durdur.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((e) => { paused = !e[0].isIntersecting; }, { threshold: 0.05 }).observe(box);
    }
    if (reduce) clearInterval(timer);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-index"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cx]').forEach((root) => {
    const cards = [...root.querySelectorAll('.cx__card')];
    if (cards.length === 0) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // .cx--reveal eklenince kartlar gizli baslar; sonra sirayla acilir. Sinifi
    // JS ekler ki JS calismazsa icerik gorunur kalsin.
    root.classList.add('cx--reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0 }
    );
    cards.forEach((card) => io.observe(card));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('[data-collection]').forEach((root) => {
    const sectionId = root.dataset.section;
    let ctrl = null;

    // --- Sade linkler: ?tur=kolye&materyal=gumus&sirala=fiyat-artan ---
    // Shopify'in filtre parametreleri (filter.p.m.custom.urun_turu_2=gid://shopify/Metaobject/...)
    // yalnizca istekte kullanilir; adres cubugu ve linkler filtre/deger adlarindan
    // uretilen sade bicimi gosterir. Esleme formdaki data-k / data-v'den gelir.
    const SORT = { 'price-ascending': 'fiyat-artan', 'price-descending': 'fiyat-azalan', 'created-descending': 'yeni', 'created-ascending': 'eski', 'best-selling': 'cok-satan', 'title-ascending': 'a-z', 'title-descending': 'z-a' };
    const SORT_BACK = Object.fromEntries(Object.entries(SORT).map(([k, v]) => [v, k]));
    const inputs = () => [...root.querySelectorAll('[data-filter-form] [data-k]')];
    const toPretty = (url) => {
      const u = new URL(url, window.location.origin);
      const out = new URLSearchParams();
      u.searchParams.forEach((v, k) => {
        if (k === 'section_id') return;
        if (k === 'sort_by') {
          if (v && v !== root.dataset.defaultSort) out.append('sirala', SORT[v] || v);
          return;
        }
        if (k.startsWith('filter.')) {
          const i = inputs().find((x) => x.name === k && (x.type === 'number' || x.value === v));
          if (i) { if (v !== '') out.append(i.dataset.k, i.type === 'number' ? v : i.dataset.v); return; }
        }
        out.append(k, v);
      });
      const q = out.toString();
      return u.pathname + (q ? `?${q}` : '');
    };
    const toReal = (url) => {
      const u = new URL(url, window.location.origin);
      const out = new URLSearchParams();
      u.searchParams.forEach((v, k) => {
        if (k === 'sirala') { out.append('sort_by', SORT_BACK[v] || v); return; }
        const i = inputs().find((x) => x.dataset.k === k && (x.type === 'number' || x.dataset.v === v));
        if (i) { out.append(i.name, i.type === 'number' ? v : i.value); return; }
        out.append(k, v);
      });
      const q = out.toString();
      return u.pathname + (q ? `?${q}` : '');
    };
    const prettyLinks = () => {
      root.querySelectorAll('a[data-ajax-link]').forEach((a) => a.setAttribute('href', toPretty(a.href)));
    };

    // --- AJAX ile sonuclari guncelle (sayfa yenilenmeden) ---
    const swap = (url, opts = {}) => {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      root.setAttribute('data-loading', '');
      url = toReal(url);
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      fetch(u.toString(), { signal: ctrl.signal })
        .then((r) => r.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('[data-collection]');
          if (fresh) {
            root.innerHTML = fresh.innerHTML;
            bind();
          }
          // Adres cubugunu sade linkle guncelle (section_id haric).
          window.history.replaceState({}, '', toPretty(url));
          root.removeAttribute('data-loading');
          root.removeAttribute('data-pending');
          if (!opts.noScroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch((e) => { if (e.name !== 'AbortError') { window.location.href = url; } });
    };

    const bind = () => {
      const form = root.querySelector('[data-filter-form]');
      if (!form) return;
      prettyLinks();

      // Filtre/siralama degisince AJAX.
      form.addEventListener('change', () => {
        const params = new URLSearchParams(new FormData(form));
        // Bos degerleri at.
        [...params.entries()].forEach(([k, v]) => { if (!v) params.delete(k); });
        const base = window.location.pathname;
        swap(params.toString() ? `${base}?${params}` : base);
      });

      // Cip / temizle linkleri de AJAX.
      root.querySelectorAll('[data-ajax-link]').forEach((a) => {
        a.addEventListener('click', (e) => { e.preventDefault(); swap(a.getAttribute('href')); });
      });

      // --- Ozel siralama menusu ---
      const sortdd = root.querySelector('[data-sort]');
      if (sortdd) {
        const btn = sortdd.querySelector('[data-sort-btn]');
        const menu = sortdd.querySelector('[data-sort-menu]');
        const input = sortdd.querySelector('[data-sort-input]');
        const label = sortdd.querySelector('[data-sort-label]');
        const closeSort = () => { menu.hidden = true; sortdd.removeAttribute('data-open'); btn.setAttribute('aria-expanded', 'false'); };
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const open = sortdd.hasAttribute('data-open');
          if (open) { closeSort(); } else { menu.hidden = false; sortdd.setAttribute('data-open', ''); btn.setAttribute('aria-expanded', 'true'); }
        });
        sortdd.querySelectorAll('[data-sort-value]').forEach((opt) => {
          opt.addEventListener('click', () => {
            input.value = opt.dataset.sortValue;
            if (label) label.textContent = opt.textContent;
            sortdd.querySelectorAll('[data-sort-value]').forEach((o) => {
              const on = o === opt;
              o.classList.toggle('is-active', on);
              o.setAttribute('aria-selected', on ? 'true' : 'false');
            });
            closeSort();
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        document.addEventListener('click', (e) => { if (!sortdd.contains(e.target)) closeSort(); });
      }

      // --- Filtre cekmecesi ac/kapat ---
      const drawer = root.querySelector('[data-filter-drawer]');
      if (drawer) {
        const openBtn = () => root.querySelector('[data-filter-open]');
        const openDrawer = () => {
          drawer.hidden = false;
          requestAnimationFrame(() => drawer.classList.add('is-open'));
          document.documentElement.style.overflow = 'hidden';
          root.dataset.filterOpen = '1';
          const b = openBtn(); if (b) b.setAttribute('aria-expanded', 'true');
        };
        const closeDrawer = () => {
          drawer.classList.remove('is-open');
          document.documentElement.style.overflow = '';
          delete root.dataset.filterOpen;
          const b = openBtn(); if (b) b.setAttribute('aria-expanded', 'false');
          setTimeout(() => { if (!root.dataset.filterOpen) drawer.hidden = true; }, 320);
        };
        root.querySelectorAll('[data-filter-open]').forEach((b) => b.addEventListener('click', openDrawer));
        root.querySelectorAll('[data-filter-close]').forEach((b) => b.addEventListener('click', closeDrawer));
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && root.dataset.filterOpen) closeDrawer(); });
        // AJAX sonrasi (innerHTML yenilendi) acik idiyse tekrar ac.
        if (root.dataset.filterOpen === '1') {
          drawer.hidden = false; drawer.classList.add('is-open');
          document.documentElement.style.overflow = 'hidden';
          const b = openBtn(); if (b) b.setAttribute('aria-expanded', 'true');
        }
      }

      // Cekmece YOKSA (eski inline tasarim) tek-panel + disari-tikla-kapat davranisi.
      // Cekmece varken facet'ler bagimsiz akordeon gibi calisir.
      if (!drawer) {
        const facets = [...root.querySelectorAll('[data-facet]')];
        facets.forEach((d) => {
          d.addEventListener('toggle', () => {
            if (d.open) facets.forEach((o) => { if (o !== d) o.open = false; });
          });
        });
        document.addEventListener('click', (e) => {
          if (!root.contains(e.target)) facets.forEach((d) => (d.open = false));
          else facets.forEach((d) => { if (d.open && !d.contains(e.target)) d.open = false; });
        });
      }

      revealCards();
      setupInfinite();
    };

    // --- Mobil: kartlar ekrana girdikce belirir (yeni kartlar da) ---
    let revealIO = null;
    const observeCards = (cards) => {
      const mobile = window.matchMedia('(max-width: 989px)').matches;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!mobile || reduce) { cards.forEach((c) => c.classList.add('is-in')); return; }
      if (!revealIO) {
        revealIO = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            revealIO.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      }
      cards.forEach((c) => revealIO.observe(c));
    };
    const revealCards = () => {
      const grid = root.querySelector('[data-reveal-grid]');
      if (grid) observeCards([...grid.children]);
    };

    // --- Sonsuz kaydirma: asagi inince sonraki sayfa AJAX ile eklenir ---
    const setupInfinite = () => {
      const inf = root.querySelector('[data-infinite]');
      if (!inf) return;
      const grid = root.querySelector('[data-reveal-grid]') || root.querySelector('.grid');
      if (!grid) return;
      const btn = inf.querySelector('[data-load-more]');
      let loading = false;

      const loadNext = () => {
        const nextUrl = inf.dataset.next;
        if (!nextUrl || loading) return;
        loading = true;
        inf.setAttribute('data-loading', '');
        const u = new URL(nextUrl, window.location.origin);
        u.searchParams.set('section_id', sectionId);
        fetch(u.toString())
          .then((r) => r.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const newGrid = doc.querySelector('.grid');
            const newCards = newGrid ? [...newGrid.children] : [];
            newCards.forEach((c) => { c.classList.remove('is-in'); grid.appendChild(c); });
            observeCards(newCards);
            // Sonraki sayfa var mi? Yoksa sentinel kalkar.
            const newInf = doc.querySelector('[data-infinite]');
            if (newInf && newInf.dataset.next && newInf.dataset.next !== nextUrl) {
              inf.dataset.next = newInf.dataset.next;
              loading = false;
              inf.removeAttribute('data-loading');
              // Sayfa az urun getirdiyse (or. tukenenler gizli oldugundan cogu
              // atlanir) sentinel hala gorunurde kalabilir; observer yeni olay
              // uretmeyince takilir. Sentinel hala yakinsa otomatik devam et.
              requestAnimationFrame(() => {
                const r = inf.getBoundingClientRect();
                if (r.top < window.innerHeight + 700) loadNext();
              });
            } else {
              io.disconnect();
              inf.remove();
            }
          })
          .catch(() => { loading = false; inf.removeAttribute('data-loading'); });
      };

      // Sentinel ekrana yaklasinca otomatik yukle; buton da manuel calisir.
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) loadNext(); });
      }, { rootMargin: '700px 0px' });
      io.observe(inf);
      if (btn) btn.addEventListener('click', loadNext);
    };

    if (root.hasAttribute('data-pending')) {
      // Sade linkle gelindi: gercek filtreli sonuclari getir.
      swap(window.location.href, { noScroll: true });
    } else {
      bind();
      // Eski (uzun) filtre linkleriyle gelindiyse adres cubugunu sadelestir.
      if (/[?&](filter\.|sort_by=)/.test(window.location.search)) window.history.replaceState({}, '', toPretty(window.location.href));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-consent"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-ckc]');
    if (!root) return;
    var KEY = 'akik_cookie_consent';
    var stored;
    try { stored = localStorage.getItem(KEY); } catch (e) { stored = null; }
    if (stored === 'accepted' || stored === 'rejected') return; // secim yapilmis

    // Shopify izin API'si (varsa) ile eslestir.
    var setConsent = function (accepted) {
      try {
        if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
          window.Shopify.customerPrivacy.setTrackingConsent(!!accepted, function () {});
        }
      } catch (e) {}
    };

    var hide = function () {
      root.classList.remove('is-in');
      setTimeout(function () { root.hidden = true; }, 450);
    };
    var choose = function (accepted) {
      try { localStorage.setItem(KEY, accepted ? 'accepted' : 'rejected'); } catch (e) {}
      setConsent(accepted);
      hide();
    };

    root.querySelector('[data-ckc-accept]').addEventListener('click', function () { choose(true); });
    root.querySelector('[data-ckc-reject]').addEventListener('click', function () { choose(false); });

    // Sayfa oturunca kisa gecikmeyle goster (belirme animasyonu).
    root.hidden = false;
    requestAnimationFrame(function () {
      setTimeout(function () { root.classList.add('is-in'); }, 600);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["favorites"] && !Shopify.designMode) return;
  try {
    
  (function () {
  const boot = () => {
  document.querySelectorAll('[data-favpage]').forEach((root) => {
    const grid = root.querySelector('[data-fav-grid]');
    const empty = root.querySelector('[data-fav-empty]');
    const countText = root.querySelector('[data-fav-count-text]');
    if (!grid || !empty) return;

    const KEY = 'akik_favorites';
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    const heart = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

    const cardHTML = (p) => {
      const img = p.image
        ? '<img class="card__img card__img--primary" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">'
        : '<div class="card__img card__img--placeholder"></div>';
      const price = p.price ? '<p class="card__price"><span>' + esc(p.price) + '</span></p>' : '';
      return '<li><article class="card">'
        + '<a href="' + esc(p.url) + '" class="card__link">'
        + '<div class="card__media">' + img + '</div>'
        + '<div class="card__body"><h3 class="card__title">' + esc(p.title) + '</h3>' + price + '</div>'
        + '</a>'
        + '<button type="button" class="card__fav is-saved" data-fav aria-pressed="true" aria-label="Favorilerden çıkar"'
        + ' data-fav-id="' + esc(p.id) + '" data-fav-handle="' + esc(p.handle) + '" data-fav-title="' + esc(p.title) + '"'
        + ' data-fav-url="' + esc(p.url) + '" data-fav-image="' + esc(p.image) + '" data-fav-price="' + esc(p.price) + '">'
        + heart + '</button>'
        + '</article></li>';
    };

    const render = () => {
      const list = read();
      if (!list.length) {
        grid.innerHTML = '';
        grid.hidden = true;
        empty.hidden = false;
        if (countText) countText.hidden = true;
        return;
      }
      empty.hidden = true;
      grid.hidden = false;
      grid.innerHTML = list.map(cardHTML).join('');
      if (countText) { countText.textContent = list.length + ' ürün'; countText.hidden = false; }
    };

    render();
    // Favori degisince (bu sayfada ya da baska sekmede) yeniden ciz.
    document.addEventListener('akik:fav-change', render);
    window.addEventListener('storage', (e) => { if (e.key === KEY) render(); });
  });
  };
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const totop = document.querySelector('[data-ft-top]');
  if (totop) {
    totop.addEventListener('click', () => {
      // Hareketi azaltmayi tercih edenler icin aninda ziplar; uzun bir sayfayi
      // yumusakca kaydirmak bu kullanicilar icin rahatsiz edicidir.
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });

    // Floating buton yalnizca sayfanin EN ALT 3 bolumunde belirir. Esik,
    // sondan 3. bolumun ust kenari viewport'a girdiginde asilir.
    const sections = [...document.querySelectorAll('.shopify-section')];
    const target = sections[sections.length - 3] || sections[0];
    const onScroll = () => {
      const show = target
        ? target.getBoundingClientRect().top < window.innerHeight * 0.9
        : window.scrollY > 600;
      totop.classList.toggle('is-visible', show);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gift]').forEach((root) => {
    const cards = [...root.querySelectorAll('.gift__card')];
    if (!cards.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.classList.add('gift--reveal');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
    cards.forEach((c) => io.observe(c));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobil alt menu: sepet bosken "Sepet"e basinca sepete GITME, "Sepetiniz boş" goster.
  // Sayac (data-cart-count) eski kalmis olabilir -> 0 gorunuyorsa /cart.js ile dogrula.
  (() => {
    const link = document.querySelector('.mnav__item--cart');
    if (!link) return;
    let toast = null;
    let hideT = 0;
    const show = () => {
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'mnav-toast';
        toast.setAttribute('role', 'status');
        toast.textContent = 'Sepetiniz boş';
        document.body.appendChild(toast);
      }
      clearTimeout(hideT);
      requestAnimationFrame(() => toast.classList.add('is-on'));
      hideT = setTimeout(() => toast.classList.remove('is-on'), 1800);
    };
    link.addEventListener('click', (e) => {
      const cnt = link.querySelector('[data-cart-count]');
      if (cnt && cnt.getAttribute('data-cart-count') !== '0') return;
      e.preventDefault();
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((c) => { if (c && c.item_count > 0) location.href = link.href; else show(); })
        .catch(() => { location.href = link.href; });
    });
  })();

  // Header sepet sayaci (ikon rozeti): bazi guncelleyiciler "(n)" yazar ->
  // sayiya cevir ve data-cart-count'u esitle (0 iken CSS gizler).
  (() => {
    document.querySelectorAll('.header__count[data-cart-count]').forEach((el) => {
      const fix = () => {
        const n = String(parseInt((el.textContent || '').replace(/\D/g, ''), 10) || 0);
        if (el.textContent !== n) el.textContent = n;
        if (el.getAttribute('data-cart-count') !== n) el.setAttribute('data-cart-count', n);
      };
      new MutationObserver(fix).observe(el, { childList: true, characterData: true, subtree: true });
      fix();
    });
  })();

  // iOS tespiti: notch dolgusu (.ios-safe-top) ve hafif scroll nudge YALNIZCA
  // iOS'ta calisir. iPadOS masaustu gibi raporladigindan dokunma sayisiyla da
  // kontrol edilir.
  const isIOS = /iP(hone|ad|od)/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isIOS) {
    document.documentElement.classList.add('is-ios');

    // Sayfa en tepedeyken cok kucuk bir scroll: iOS'un ust alani (notch/status
    // bar + safe-area) dogru hesaplayip doldurmasini tetikler. Boylece notch
    // ilk andan itibaren dolu gorunur (elle scroll beklemeye gerek kalmaz).
    const nudge = () => {
      if (window.scrollY === 0) window.scrollTo(0, 1);
    };
    if (document.readyState === 'complete') {
      requestAnimationFrame(nudge);
    } else {
      window.addEventListener('load', () => requestAnimationFrame(nudge), { once: true });
    }
  }

  // Kaydirma durumu. Sinif <body>'ye yazilir, header'a degil: header'in
  // altindaki guven seridi de ayni sinyale tepki vermek zorunda. Ortak bir
  // ust elemana yazmak, ikisinin senkron kalmasini garanti eder.
  const sentinel = document.querySelector('.header-sentinel');

  if (sentinel) {
    new IntersectionObserver(
      ([entry]) => document.body.classList.toggle('is-scrolled', !entry.isIntersecting),
      { threshold: 0 }
    ).observe(sentinel);
  }

  // Logo rengi (mobil): header'in arkasindaki bolum koyu/gorselli mi?
  // data-header-dark isaretli ogeler (hero, split, video karesi) header
  // cizgisini (ust ~42px) kesiyorsa BEYAZ logo (body.header-dark), yoksa KOYU.
  const darkZones = document.querySelectorAll('[data-header-dark]');
  if (darkZones.length) {
    const LINE = 42;
    let ticking = false;
    const updateLogo = () => {
      let onDark = false;
      for (const z of darkZones) {
        const r = z.getBoundingClientRect();
        if (r.top <= LINE && r.bottom >= LINE) { onDark = true; break; }
      }
      document.body.classList.toggle('header-dark', onDark);
      ticking = false;
    };
    const onScrollLogo = () => {
      if (!ticking) { ticking = true; requestAnimationFrame(updateLogo); }
    };
    window.addEventListener('scroll', onScrollLogo, { passive: true });
    window.addEventListener('resize', onScrollLogo, { passive: true });
    updateLogo();
  }

  // Mobil cekmece (tam-ekran menu). Birden fazla tetikleyici olabilir
  // (gizli header burger + alt gezinme cubugundaki "Menü"); hepsi baglanir.
  const drawer = document.querySelector('[data-drawer]');

  if (drawer) {
    const triggers = document.querySelectorAll('[data-drawer-open], [data-drawer-toggle]');
    const isOpen = () => drawer.classList.contains('is-open');
    const setExpanded = (v) => triggers.forEach((b) => b.setAttribute('aria-expanded', v));
    let hideTimer = null;

    const open = () => {
      clearTimeout(hideTimer);
      drawer.hidden = false;
      // menu-open <body>'ye: alt gezinmedeki "Menü" ogesi ×'e doner.
      document.body.classList.add('menu-open');
      // Panel/linkler suzulerek girsin diye baslangic durumu bir kare gorulmeli.
      requestAnimationFrame(() => drawer.classList.add('is-open'));
      setExpanded('true');
      document.documentElement.style.overflow = 'hidden';
    };

    const close = () => {
      drawer.classList.remove('is-open');
      document.body.classList.remove('menu-open');
      setExpanded('false');
      document.documentElement.style.overflow = '';
      // Sabit sure: link gecisleri kapanisi erken tetiklemesin.
      hideTimer = setTimeout(() => {
        drawer.hidden = true;
        // Kapaninca kategori secimini sifirla: yeni acilista hicbiri acik gelmesin.
        // Acik alt sayfalari sifirla: yeni acilista level-1 listeye don.
        drawer.querySelectorAll('[data-sub], [data-sub2]').forEach((s) => { s.classList.remove('is-open'); s.hidden = true; });
        drawer.classList.remove('is-subopen');
      }, 620);
    };

    document.querySelectorAll('[data-drawer-open]').forEach((b) => b.addEventListener('click', open));
    document.querySelectorAll('[data-drawer-toggle]').forEach((b) =>
      b.addEventListener('click', () => (isOpen() ? close() : open()))
    );
    drawer.querySelectorAll('[data-drawer-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen()) close();
    });

    // --- Dil Sec kutucugu: alttaki dil listesini ac/kapat ---
    const langToggle = drawer.querySelector('[data-lang-toggle]');
    const langPanel = drawer.querySelector('.drawer__langs');
    if (langToggle && langPanel) {
      langToggle.addEventListener('click', () => {
        const open = langPanel.classList.toggle('is-open');
        langToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // --- Messika alt sayfa: kategoriye basinca sagdan gorselli koleksiyonlar kayar ---
    drawer.querySelectorAll('[data-open-sub]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const sub = drawer.querySelector('[data-sub="' + btn.getAttribute('data-open-sub') + '"]');
        if (!sub) return;
        // Yeni acilista 3. seviye panelleri sifirla (level-2 listeden baslasin).
        sub.querySelectorAll('[data-sub2]').forEach((s2) => { s2.classList.remove('is-open'); s2.hidden = true; });
        sub.hidden = false;
        const sc = sub.querySelector('.drawer__sub-scroll');
        if (sc) sc.scrollTop = 0;
        // Alt sayfa acikken alttaki 3 ikon (favori/takip/dil) gizlensin.
        drawer.classList.add('is-subopen');
        requestAnimationFrame(() => sub.classList.add('is-open'));
      });
    });
    drawer.querySelectorAll('[data-close-sub]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const sub = btn.closest('[data-sub]');
        if (!sub) return;
        sub.classList.remove('is-open');
        drawer.classList.remove('is-subopen');
        setTimeout(() => {
          if (!sub.classList.contains('is-open')) {
            sub.hidden = true;
            sub.querySelectorAll('[data-sub2]').forEach((s2) => { s2.classList.remove('is-open'); s2.hidden = true; });
          }
        }, 460);
      });
    });

    // --- 3. seviye (torun) alt sayfa: parent satirina basinca sagdan kayar ---
    drawer.querySelectorAll('[data-open-sub2]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const sub2 = drawer.querySelector('[data-sub2="' + btn.getAttribute('data-open-sub2') + '"]');
        if (!sub2) return;
        sub2.hidden = false;
        const sc = sub2.querySelector('.drawer__sub-scroll');
        if (sc) sc.scrollTop = 0;
        requestAnimationFrame(() => sub2.classList.add('is-open'));
      });
    });
    drawer.querySelectorAll('[data-close-sub2]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const sub2 = btn.closest('[data-sub2]');
        if (!sub2) return;
        sub2.classList.remove('is-open');
        setTimeout(() => { if (!sub2.classList.contains('is-open')) sub2.hidden = true; }, 460);
      });
    });
  }

  // --- Arama: yazma efektli placeholder ---
  // Kategorileri (Gumus kolye, Gumus yuzuk...) sirayla yazip siler. Kullanici
  // alana odaklanir odaklanmaz durur; JS/animasyon yoksa duz placeholder kalir.
  document.querySelectorAll('[data-typewriter]').forEach((input) => {
    const form = input.closest('form');
    const phrases = (form && form.dataset.phrases ? form.dataset.phrases : '')
      .split('|')
      .map((s) => s.trim())
      .filter(Boolean);
    if (!phrases.length) return;

    const idle = 'Ara…';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      input.placeholder = phrases[0];
      return;
    }

    let pi = 0;
    let ci = 0;
    let deleting = false;
    let stopped = false;

    const tick = () => {
      if (stopped) return;
      const word = phrases[pi];
      if (!deleting) {
        ci += 1;
        input.placeholder = word.slice(0, ci);
        if (ci >= word.length) {
          deleting = true;
          setTimeout(tick, 1500); // tam kelimeyi bir sure tut
          return;
        }
        setTimeout(tick, 85);
      } else {
        ci -= 1;
        input.placeholder = word.slice(0, ci);
        if (ci <= 0) {
          deleting = false;
          pi = (pi + 1) % phrases.length;
          setTimeout(tick, 350);
          return;
        }
        setTimeout(tick, 40);
      }
    };

    const stop = () => {
      stopped = true;
      input.placeholder = idle;
    };
    input.addEventListener('focus', stop, { once: true });
    input.addEventListener('input', stop, { once: true });

    setTimeout(tick, 700);
  });

  // --- Ortak canli predictive arama ---
  // Aranan alanlar: baslik, tip, varyant, SKU, BARKOD, marka, etiket -> urun /
  // renk / barkod / SKU hepsi bulunur. Hem ustten acilan katmanda hem menu
  // icindeki arama kutusunda ayni mantik kullanilir.
  const SEARCH_FIELDS = 'title,product_type,variants.title,variants.sku,variants.barcode,vendor,tag';

  // Joker (prefix) arama: her terime '*' ekler -> "kol", "gumus yuz", "LACJ20"
  // gibi YARIM (bastan) girdiler eslesir. Shopify yalnizca kelime BASINDAN
  // eslestirdigi icin ortadan/sondan (or. SKU'nun sadece rakam kismi) eslesmez.
  const wild = (s) =>
    (s || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map((t) => (/[*"]$/.test(t) ? t : t + '*'))
      .join(' ');

  // Alan onekli sorgu: harfli her kelime urun ADI / TIPI / MARKASINDA ya da
  // TAM ETIKET olarak aranir (alt kategoriler /collections/x/baget etiketle
  // calisir) -> aciklama ve yazim hatasi ("baget" -> "bagel") eslesmeleri
  // gelmez. Rakamli kelimeler (SKU/barkod) oneksiz kalir. Sonuc sayfasi
  // (search.liquid) bu bicimi cozer; bos donerse normal aramaya duser.
  // Esanlamlilar (snippets/search-synonyms): "tesbih" aranirsa "tespih" de aranir.
  // Varyantlar " OR title:" ile eklenir; arama sayfasi yalnizca grubun ILK title:'ini
  // musterinin kelimesi sayar (link ve gosterim "tesbih" kalir).
  const synFold = (t) => t.toLocaleLowerCase('tr').replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c');
  const synOf = (t) => {
    const f = synFold(t);
    const g = (window.akikSearchSyn || '').split('|').map((x) => x.split(',').map((v) => v.trim()).filter(Boolean)).find((x) => x.includes(f));
    return g ? [t, ...g.filter((v) => v !== f)] : [t];
  };
  const fieldQuery = (s) =>
    (s || '')
      .replace(/[()"*:]/g, ' ')
      .trim()
      .split(/\s+/)
      .filter((t) => t && !/^(OR|AND|NOT)$/.test(t))
      .map((t) => (/\d/.test(t) ? t + '*' : `(${synOf(t).map((v) => `title:${v}* OR product_type:${v}* OR vendor:${v}* OR tag:${v}`).join(' OR ')})`))
      .join(' ');
  // Musterinin gordugu/paylastigi link sade kalir (?q=zultanit+tesbih); alan onekli
  // sorguyu arama sayfasi (search.liquid) arka planda kurar.
  const searchHref = (s, action) => `${action || '/search'}?q=${encodeURIComponent((s || '').trim()).replace(/%20/g, '+')}&type=product`;

  // Sonuc yoksa gevsetilmis sorgular: once TAM (AND), sonra herhangi kelime (OR),
  // sonra alfanumerik parcalar, en son en uzun kelime. "En yakin" sonuc getirir.
  const buildQueries = (s) => {
    const terms = (s || '').trim().split(/\s+/).filter(Boolean);
    const w = (t) => (/[*"]$/.test(t) ? t : t + '*');
    const list = [terms.map(w).join(' ')];
    if (terms.length > 1) list.push(terms.map(w).join(' OR '));
    const chunks = [];
    terms.forEach((t) => {
      const parts = t.match(/[a-zA-Z]+|[0-9]+/g);
      if (parts && parts.length > 1) parts.forEach((p) => { if (p.length >= 3) chunks.push(w(p)); });
    });
    if (chunks.length) list.push([...new Set(chunks)].join(' OR '));
    const longest = terms.slice().sort((a, b) => b.length - a.length)[0];
    if (longest && longest.length >= 3) list.push(w(longest));
    return [...new Set(list)];
  };

  // Shopify'in yazim hatasi toleransi kapatilamiyor: "baget" yazinca "bagel"
  // de geliyor. Kati modda her harfli kelime urunun baslik/tip/marka/etiket-
  // lerinden birinde KELIME BASI olarak gecmeli (aciklama sayilmaz). Rakamli kelimeler (SKU/
  // barkod) suzulmez -- bu alanlar yanitta gelmedigi icin Shopify'a guvenilir.
  // Turkce harf katlama: "altin" = "altın", "gumus" = "gümüş" (Shopify da boyle eslestirir).
  const TR_FOLD = { 'ı': 'i', 'ş': 's', 'ğ': 'g', 'ü': 'u', 'ö': 'o', 'ç': 'c', 'â': 'a', 'î': 'i', 'û': 'u' };
  const trNorm = (s) => (s || '').toLocaleLowerCase('tr').normalize('NFC').replace(/[ışğüöçâîû]/g, (c) => TR_FOLD[c]);
  const matchesAll = (p, q) => {
    const terms = trNorm(q).replace(/[*"]/g, '').split(/\s+/).filter((t) => t && !/\d/.test(t));
    if (!terms.length) return true;
    const hay = ' ' + trNorm([
      p.title, p.type, p.vendor, (p.tags || []).join(' ')
    ].join(' ')).replace(/[^\p{L}\p{N}]+/gu, ' ');
    // Esanlamli grubundan herhangi biri yeter ("tesbih" -> "Tespih").
    if (terms.every((t) => synOf(t).some((v) => hay.indexOf(' ' + trNorm(v)) !== -1))) return true;
    // Bitisik etiket: "marka takilar" -> etiket "markatakilar".
    return terms.length > 1 && hay.indexOf(' ' + terms.join('')) !== -1;
  };

  const fmtMoney = (v, cur) => {
    const n = parseFloat(v);
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(n);
    } catch (e) { return v; }
  };

  const attachPredictive = (input, resultsEl, cur, cls) => {
    if (!input || !resultsEl) return;
    let debounce = null;
    let ctrl = null;
    const card = (p, klass) => {
      const img = p.featured_image && p.featured_image.url
        ? `<img class="${cls.thumb}" src="${p.featured_image.url}" alt="" loading="lazy">`
        : `<span class="${cls.thumb}" aria-hidden="true"></span>`;
      const price = p.price ? `<div class="${cls.price}">${fmtMoney(p.price, cur)}</div>` : '';
      return `<a class="${klass}" href="${p.url}">${img}<div class="${cls.meta}"><div class="${cls.title}">${p.title}</div>${price}</div></a>`;
    };
    const render = (products, q) => {
      if (!products.length) {
        resultsEl.innerHTML = `<span class="${cls.empty}">"${q}" için sonuç bulunamadı.</span>`;
        return;
      }
      const all = cls.all ? `<a class="${cls.all}" href="${searchHref(q)}">Tüm sonuçlar →</a>` : '';
      // Modal (cls.featured): spesifik/tam eslesme varsa o urun EN USTE vurgulu;
      // altinda "Yakin sonuclar". Tam eslesme yoksa normal izgara.
      if (cls.featured) {
        // Kod gibi arama (tek kelime + rakam: SKU / EAN / barkod): TEK urun goster,
        // digerlerini/yakin sonuclari hic gosterme.
        var qc = q.trim();
        if (!/\s/.test(qc) && /\d/.test(qc) && qc.length >= 5 && products.length) {
          resultsEl.innerHTML = '<p class="' + cls.foundhead + '">Aradığınız ürün</p>' + card(products[0], cls.featured);
          return;
        }
        const norm = (s) => (s || '').toLocaleLowerCase('tr').replace(/\s+/g, ' ').trim();
        const nq = norm(q);
        const exactIdx = nq ? products.findIndex((p) => norm(p.title).indexOf(nq) !== -1) : -1;
        if (exactIdx >= 0) {
          const feat = products[exactIdx];
          const near = products.filter((_, i) => i !== exactIdx);
          let html = `<p class="${cls.foundhead}">Aradığınız ürün</p>` + card(feat, cls.featured);
          if (near.length) {
            html += `<p class="${cls.nearhead}">Yakın sonuçlar</p>` + near.map((p) => card(p, cls.item)).join('');
          }
          resultsEl.innerHTML = html + all;
          return;
        }
      }
      resultsEl.innerHTML = products.map((p) => card(p, cls.item)).join('') + all;
    };
    const run = (q) => {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const signal = ctrl.signal;
      let queries;
      if (cls.strict) {
        // Kademeler: 1) ad/tip/marka KESIN  2) etiketler dahil KESIN ("Marka
        // Takilar")  3) hic kesin yoksa ad/tip/marka uzerinde Shopify'in yazim
        // hatasi toleransi ("altn", "kolyee"). Kesin varsa benzer GOSTERILMEZ
        // ("baget" -> "bagel" yok).
        const fq = fieldQuery(q);
        // (Alan onekli sorguda Shopify yazim hatasi toleransini kapatiyor; bu
        // yuzden 3. kademe oneksiz sorgu + alanlar ad/tip/marka ile sinirli.)
        queries = [
          { q: fq, exact: true },
          { q: wild(q), exact: true },
          { q: wild(q), exact: false, fields: 'title,product_type,variants.title,vendor' },
        ];
      } else {
        queries = buildQueries(q).map((x) => ({ q: x, exact: false }));
      }
      const cache = {};
      // Rakamli arama (barkod / stok kodu): suggest.json varyant SKU/barkod
      // dondurmez ve Shopify benzer kodlu alakasiz urun getirebilir
      // ("30077300" -> Tommy THJ2790513). Arama sayfasinin kati suzgeci
      // (search-term-match: SKU/barkod BASI) ile dogrula; yalniz onun gecirdigi
      // urunler kalir. Sonuc sorgu basina bir kez cekilir.
      let codeSet = null;
      const verifyCodes = (products) => {
        if (!codeSet) {
          codeSet = fetch(`/search?q=${encodeURIComponent(fieldQuery(q))}&type=product&section_id=search`, { signal })
            .then((r) => r.text())
            .then((html) => {
              const grid = (html.split('data-sp-results')[1] || '').split('data-search-nearest')[0];
              return new Set([...grid.matchAll(/href="\/products\/([^"?#\/]+)/g)].map((m) => decodeURIComponent(m[1])));
            });
        }
        return codeSet.then((set) => products.filter((p) => set.has(p.handle)));
      };
      const attempt = (i) => {
        if (i >= queries.length) { render([], q); return; }
        const { q: qs, exact, fields } = queries[i];
        const key = qs + '|' + (fields || '');
        const use = (products) => {
          if (exact) products = products.filter((p) => matchesAll(p, q));
          const done = (list) => {
            if (cls.strict) list = list.slice(0, 8);
            // Bulunca goster; bos ise bir sonraki (daha gevsek) sorguyu dene.
            if (!list.length) return attempt(i + 1);
            render(list, q);
          };
          if (/\d/.test(q) && products.length) {
            verifyCodes(products).then(done).catch((e) => { if (e.name !== 'AbortError') done([]); });
            return;
          }
          done(products);
        };
        if (cache[key]) return use(cache[key]);
        const url = `/search/suggest.json?q=${encodeURIComponent(qs)}`
          + `&resources[type]=product&resources[limit]=${cls.strict ? 10 : 8}`
          + `&resources[options][unavailable_products]=last`
          + `&resources[options][fields]=${fields || SEARCH_FIELDS}`;
        fetch(url, { signal })
          .then((r) => r.json())
          .then((data) => {
            const products = (data.resources && data.resources.results && data.resources.results.products) || [];
            cache[key] = products;
            use(products);
          })
          .catch((e) => { if (e.name !== 'AbortError') { if (i + 1 < queries.length) attempt(i + 1); else resultsEl.innerHTML = ''; } });
      };
      attempt(0);
    };
    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(debounce);
      if (q.length < 2) { resultsEl.innerHTML = ''; return; }
      debounce = setTimeout(() => run(q), 200);
    });
  };

  // --- Form gonderiminde (Enter) joker arama ---
  // Butun arama kutulari (ust katman, menu, sonuc sayfasi) Enter'a basilinca
  // terimleri '*' ile prefix aramaya cevirip sonuc sayfasina gider. Boylece
  // yarim (bastan) girdiler de eslesir.
  const searchForms = new Set();
  document.querySelectorAll('input[name="q"]').forEach((input) => {
    const form = input.closest('form[action]');
    if (form) searchForms.add(form);
  });
  searchForms.forEach((form) => {
    form.addEventListener('submit', (e) => {
      const input = form.querySelector('input[name="q"]');
      const val = input && input.value.trim();
      if (!val) return;
      e.preventDefault();
      const action = form.getAttribute('action') || '/search';
      window.location.href = searchHref(val, action);
    });
  });

  // --- Ustten acilan arama katmani (alt navbar "Ara") ---
  const msearch = document.querySelector('[data-msearch]');
  if (msearch) {
    const input = msearch.querySelector('[data-msearch-input]');
    const openBtns = document.querySelectorAll('[data-search-open]');
    const closeBtns = msearch.querySelectorAll('[data-search-close]');
    let hideTimer = null;

    const isOpen = () => msearch.classList.contains('is-open');
    const open = () => {
      clearTimeout(hideTimer);
      msearch.hidden = false;
      requestAnimationFrame(() => msearch.classList.add('is-open'));
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      document.documentElement.style.overflow = 'hidden';
      // preventScroll: focus'un sayfayi input'a kaydirmasini (ekran kaymasi) engeller.
      setTimeout(() => { try { input && input.focus({ preventScroll: true }); } catch (e) { input && input.focus(); } }, 120);
    };
    const close = () => {
      msearch.classList.remove('is-open');
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      document.documentElement.style.overflow = '';
      hideTimer = setTimeout(() => { msearch.hidden = true; }, 320);
    };
    openBtns.forEach((b) => b.addEventListener('click', open));
    closeBtns.forEach((b) => b.addEventListener('click', close));
    msearch.addEventListener('click', (e) => { if (e.target === msearch) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isOpen()) close(); });

    attachPredictive(input, msearch.querySelector('[data-msearch-results]'), msearch.dataset.currency || 'TRY', {
      item: 'msearch__item', thumb: 'msearch__thumb', meta: 'msearch__meta',
      title: 'msearch__title', price: 'msearch__price', empty: 'msearch__empty', all: 'msearch__all',
    });
  }

  // --- Menu ici arama kutusu (canli, kendi icinde) ---
  const dbox = document.querySelector('.drawer__searchbox');
  if (dbox) {
    attachPredictive(dbox.querySelector('[data-drawer-search-input]'), dbox.querySelector('[data-drawer-results]'), dbox.dataset.currency || 'TRY', {
      item: 'drawer__result', thumb: 'drawer__result-thumb', meta: 'drawer__result-meta',
      title: 'drawer__result-title', price: 'drawer__result-price', empty: 'drawer__results-empty', all: '',
    });
  }

  // --- Header ustundeki arama kutusu (canli, acilir katman) ---
  const hsearch = document.querySelector('.ann-search');
  if (hsearch) {
    const hInput = hsearch.querySelector('[data-header-search-input]');
    const hResults = hsearch.querySelector('[data-header-results]');
    const hCur = (document.querySelector('[data-currency]') || { dataset: {} }).dataset.currency || 'TRY';
    attachPredictive(hInput, hResults, hCur, {
      item: 'ann-search__result', thumb: 'ann-search__result-thumb', meta: 'ann-search__result-meta',
      title: 'ann-search__result-title', price: 'ann-search__result-price', empty: 'ann-search__empty', all: 'ann-search__all',
    });
    // Disari tiklayinca / Escape ile sonuclari kapat.
    document.addEventListener('click', (e) => { if (!hsearch.contains(e.target)) hResults.innerHTML = ''; });
    hInput && hInput.addEventListener('keydown', (e) => { if (e.key === 'Escape') { hResults.innerHTML = ''; hInput.blur(); } });
  }

  // --- Messika tarzi tam ekran arama modali ---
  const ssearch = document.getElementById('SiteSearch');
  if (ssearch) {
    const sInput = ssearch.querySelector('[data-ssearch-input]');
    const sResults = ssearch.querySelector('[data-ssearch-results]');
    const sCur = (document.querySelector('[data-currency]') || { dataset: {} }).dataset.currency || 'TRY';
    const setExpanded = (v) => document.querySelectorAll('[data-ssearch-open]').forEach((b) => b.setAttribute && b.setAttribute('aria-expanded', v));

    const openSS = () => {
      if (ssearch.hasAttribute('hidden')) {
        ssearch.removeAttribute('hidden');
        requestAnimationFrame(() => ssearch.classList.add('is-open'));
        document.documentElement.style.overflow = 'hidden';
      }
      setExpanded('true');
      setTimeout(() => { if (sInput) sInput.focus(); }, 80);
    };
    const closeSS = () => {
      ssearch.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setExpanded('false');
      if (sInput) sInput.blur();
      setTimeout(() => ssearch.setAttribute('hidden', ''), 300);
    };

    // Acma tetikleri: header kutusu (readonly input) + mobil "Ara" butonlari.
    document.querySelectorAll('[data-ssearch-open]').forEach((el) => {
      const handler = (e) => { e.preventDefault(); openSS(); };
      el.addEventListener('click', handler);
      if (el.matches('input')) el.addEventListener('focus', handler);
    });
    ssearch.querySelectorAll('[data-ssearch-close]').forEach((b) => b.addEventListener('click', closeSS));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && ssearch.classList.contains('is-open')) closeSS(); });

    // Canli urun izgarasi: mevcut attachPredictive'i modal grid class'lariyla yeniden kullan.
    attachPredictive(sInput, sResults, sCur, {
      item: 'ssearch__card', thumb: 'ssearch__card-img', meta: 'ssearch__card-meta',
      title: 'ssearch__card-title', price: 'ssearch__card-price', empty: 'ssearch__empty', all: 'ssearch__all',
      featured: 'ssearch__featured', foundhead: 'ssearch__foundhead', nearhead: 'ssearch__nearhead',
      strict: true,
    });

    // Populer arama cipleri: inputa yaz + sonuclari getir.
    ssearch.querySelectorAll('[data-ssearch-term]').forEach((b) => {
      b.addEventListener('click', () => {
        if (!sInput) return;
        sInput.value = b.getAttribute('data-ssearch-term') || '';
        sInput.dispatchEvent(new Event('input', { bubbles: true }));
        sInput.focus();
      });
    });
    // Enter ile joker arama: genel 'input[name=q]' form gonderimi zaten ele alir.

    // --- Sesli arama (Web Speech API; Chrome/Safari/Edge). Desteklenmiyorsa buton gizli kalir. ---
    const micBtn = ssearch.querySelector('[data-ssearch-mic]');
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (micBtn && SR && sInput) {
      micBtn.hidden = false;
      let rec = null;
      const placeholder = sInput.placeholder;
      const stop = () => {
        micBtn.classList.remove('is-listening');
        micBtn.setAttribute('aria-label', 'Sesle ara');
        sInput.placeholder = placeholder;
      };
      micBtn.addEventListener('click', () => {
        if (rec) { rec.stop(); return; }
        rec = new SR();
        rec.lang = 'tr-TR';
        rec.interimResults = true;
        rec.maxAlternatives = 1;
        rec.onstart = () => {
          micBtn.classList.add('is-listening');
          micBtn.setAttribute('aria-label', 'Dinlemeyi durdur');
          sInput.value = '';
          sInput.placeholder = 'Dinliyorum…';
        };
        rec.onresult = (e) => {
          const text = [...e.results].map((r) => r[0].transcript).join('').trim();
          sInput.value = text;
          sInput.dispatchEvent(new Event('input', { bubbles: true }));
        };
        rec.onerror = (e) => {
          if (e.error === 'not-allowed' || e.error === 'service-not-allowed') sInput.placeholder = 'Mikrofon izni verilmedi';
        };
        rec.onend = () => {
          rec = null;
          const keepMsg = sInput.placeholder === 'Mikrofon izni verilmedi';
          stop();
          if (keepMsg) { sInput.placeholder = 'Mikrofon izni verilmedi'; setTimeout(() => { sInput.placeholder = placeholder; }, 2500); }
        };
        try { rec.start(); } catch (err) { rec = null; stop(); }
      });
      // Modal kapanirken dinlemeyi birak.
      ssearch.querySelectorAll('[data-ssearch-close]').forEach((b) => b.addEventListener('click', () => { if (rec) rec.abort(); }));
    }
  }

  // --- Global favori (istek listesi) sistemi ---
  // Tum sayfalarda calisir. Favoriler cihazda (localStorage) saklanir; her
  // favori ogesi urunun temel bilgisiyle (baslik, gorsel, fiyat, link) tutulur
  // ki Favorilerim sayfasi ekstra istek atmadan render edebilsin.
  // Butonlar: [data-fav] + data-fav-id/handle/title/url/image/price.
  (function () {
    const KEY = 'akik_favorites';
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
    const write = (list) => {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('akik:fav-change', { detail: { count: list.length, list: list } }));
    };
    const has = (id) => read().some((x) => String(x.id) === String(id));
    const toggle = (item) => {
      let list = read();
      if (list.some((x) => String(x.id) === String(item.id))) list = list.filter((x) => String(x.id) !== String(item.id));
      else list = list.concat([item]);
      write(list);
      return list.some((x) => String(x.id) === String(item.id));
    };
    window.AkikFav = { read: read, write: write, has: has, toggle: toggle, KEY: KEY };

    const syncBtn = (btn) => {
      const on = has(btn.getAttribute('data-fav-id'));
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Favorilerden çıkar' : 'Favorilere ekle');
    };
    const syncAll = () => document.querySelectorAll('[data-fav]').forEach(syncBtn);
    const syncCount = (c) => document.querySelectorAll('[data-fav-count]').forEach((el) => { el.textContent = c; el.hidden = c === 0; });

    // Tiklama delegasyonu -> dinamik eklenen kartlarda da calisir.
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-fav]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const item = {
        id: btn.getAttribute('data-fav-id'),
        handle: btn.getAttribute('data-fav-handle'),
        title: btn.getAttribute('data-fav-title'),
        url: btn.getAttribute('data-fav-url'),
        image: btn.getAttribute('data-fav-image'),
        price: btn.getAttribute('data-fav-price')
      };
      if (!item.id) return;
      toggle(item);
      const sel = (window.CSS && CSS.escape) ? CSS.escape(item.id) : item.id;
      document.querySelectorAll('[data-fav][data-fav-id="' + sel + '"]').forEach(syncBtn);
    });

    document.addEventListener('akik:fav-change', (e) => { syncCount(e.detail.count); });

    const init = () => { syncAll(); syncCount(read().length); };
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);

    // Sonsuz kaydirma/filtre ile eklenen kartlari senkronla.
    if ('MutationObserver' in window) {
      const mo = new MutationObserver((muts) => {
        let need = false;
        muts.forEach((m) => m.addedNodes && m.addedNodes.forEach((n) => {
          if (n.nodeType === 1 && ((n.matches && n.matches('[data-fav]')) || (n.querySelector && n.querySelector('[data-fav]')))) need = true;
        }));
        if (need) syncAll();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  })();

  // Mobil klavye acikken alt menuyu (mnav) + 'Sepete Ekle' cubugunu gizle.
  // Klavye acilinca gizler, YALNIZCA gercekten kapaninca gosterir. Scroll
  // sirasindaki gecici odak/viewport degisimlerine aldirmaz (histerezis) ->
  // scroll yapinca cubuklar geri GELMEZ.
  (function () {
    var kbdSel = 'input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]):not([type=reset]):not([type=file]):not([type=range]):not([type=color]), textarea, [contenteditable="true"]';
    var root = document.documentElement;
    var open = false;
    var set = function (v) { if (v !== open) { open = v; root.classList.toggle('kbd-open', v); } };
    var vvShrink = function () {
      return window.visualViewport ? (window.innerHeight - window.visualViewport.height) : 0;
    };
    var focusTime = 0;
    // Yazi alanina odaklaninca hemen gizle.
    document.addEventListener('focusin', function (e) {
      if (e.target && e.target.matches && e.target.matches(kbdSel)) { set(true); focusTime = Date.now(); }
    });
    // Klavye acikken SCROLL yapilinca klavyeyi otomatik KAPAT (alani blur et).
    // Boylece cubuklar klavyenin ustunde tuhaf durmaz; klavye kapaninca normal
    // yerlerine doner. Odak aninda tarayicinin kendi kaydirmasini yutmak icin
    // ilk ~350ms atlanir.
    var onScroll = function () {
      var a = document.activeElement;
      if (a && a.matches && a.matches(kbdSel) && (Date.now() - focusTime > 350)) {
        try { a.blur(); } catch (err) {}
        set(false);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('touchmove', onScroll, { passive: true });
    // VisualViewport: klavye acikken viewport kucuk kalir. Histerezis:
    //  >120px kucukse ac; <60px'e donunce kapat; arada mevcut durumu koru
    //  (scroll'da 60-120 bandinda titremeyi engeller).
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        var s = vvShrink();
        if (s > 120) set(true);
        else if (s < 60) set(false);
      });
    }
    // Odak kaybinda YALNIZCA klavye de kapaliysa (viewport tam) goster.
    document.addEventListener('focusout', function (e) {
      if (e.target && e.target.matches && e.target.matches(kbdSel)) {
        setTimeout(function () {
          var a = document.activeElement;
          var stillField = !!(a && a.matches && a.matches(kbdSel));
          if (!stillField && vvShrink() < 100) set(false);
        }, 160);
      }
    });
  })();

  // --- Masaustu mega: iki panel ("sectikce acilan") ---
  // Sol kategoriye gelince (hover/focus) sag panelde torunlari acilir.
  (function () {
    document.querySelectorAll('[data-mega-two]').forEach(function (two) {
      var parents = two.querySelectorAll('[data-mega-parent]');
      var panels = two.querySelectorAll('[data-mega-panel]');
      function activate(idx) {
        var panel = two.querySelector('[data-mega-panel="' + idx + '"]');
        parents.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-mega-parent') === idx); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-mega-panel') === idx); });
        // Torunu/gorseli yoksa sag paneli kapat (ekstra alan kalmasin).
        two.classList.toggle('is-collapsed', !panel);
      }
      function clearAll() {
        parents.forEach(function (p) { p.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        two.classList.add('is-collapsed');
      }
      parents.forEach(function (p) {
        var idx = p.getAttribute('data-mega-parent');
        var link = p.querySelector('.mega__lvl1-link');
        p.addEventListener('mouseenter', function () { activate(idx); });
        if (link) link.addEventListener('focus', function () { activate(idx); });
      });
      // Baslangicta ve menuden cikinca: hicbir panel acik degil.
      var nav = two.closest('.header__nav-item');
      if (nav) nav.addEventListener('mouseleave', clearAll);
      clearAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Hareketi azaltmayi tercih eden kullanicilarda arka plan videosu oynamaz;
  // poster karesinde durur. Otomatik oynayan tam ekran bir video, bu tercihi
  // yapan kullanicilar icin en rahatsiz edici ogedir.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.hero video, video.hero__image').forEach((v) => {
      v.autoplay = false;
      v.pause();
    });
  }

  document.querySelectorAll('[data-hero]').forEach((hero) => {
    const slides = [...hero.querySelectorAll('[data-slide]')];
    if (slides.length < 2) return;

    const dots = [...hero.querySelectorAll('[data-hero-dot]')];
    let index = 0;
    let timer = null;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((s, i) => {
        const active = i === index;
        s.classList.toggle('is-active', active);
        // Performans: yalnizca aktif slaytin videosu oynar, digerleri durur.
        const v = s.querySelector('video');
        if (v && !reduce) {
          if (active) { v.play?.().catch(() => {}); } else { v.pause?.(); }
        }
      });
      dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    };

    // Baslangicta video durumlarini esitle (ilk slayt oynar, digerleri durur).
    show(index);

    const stop = () => clearTimeout(timer);

    // Her slayt kendi suresini tasiyabilir (data-duration, ms). Indirim slaytı
    // 10 sn durur; digerleri bolum ayarindaki sureyi kullanir. setInterval
    // yerine yeniden kurulan setTimeout: aktif slaytin suresine gore beklenir.
    const start = () => {
      if (hero.dataset.autoplay !== 'true') return;
      // Hareketi azaltmayi tercih eden kullanicilar icin otomatik gecis yok:
      // kontrolu elinden alinan bir slayt gosterisi erisilebilirlik sorunudur.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop();
      const base = Number(hero.dataset.interval) || 6000;
      const dur = Number(slides[index] && slides[index].dataset.duration) || base;
      timer = setTimeout(() => { show(index + 1); start(); }, dur);
    };

    // Kullanici mudahale ettiginde otomatik gecisi yeniden baslat, yoksa
    // tiklamanin hemen ardindan slayt kayabilir.
    const go = (next) => { show(next); start(); };

    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    // --- Surukle / kaydir (mouse + dokunmatik) ile slayt degistir ---
    // Yatay hareket esigi asilinca yon'e gore onceki/sonraki slayta gecer.
    // Dikey kaydirma (sayfa scroll) engellenmez: yalnizca belirgin yatay
    // harekette devreye girer.
    let dragX = 0, dragY = 0, dragging = false, decided = false, horizontal = false;
    const THRESH = 50;

    const onDown = (x, y) => {
      dragX = x; dragY = y; dragging = true; decided = false; horizontal = false;
      stop();
    };
    const onMove = (x, y, e) => {
      if (!dragging) return;
      const dx = x - dragX, dy = y - dragY;
      if (!decided && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
        decided = true;
        horizontal = Math.abs(dx) > Math.abs(dy);
      }
      // Yatay suruklemede sayfanin dikey kaymasini engelle.
      if (decided && horizontal && e.cancelable) e.preventDefault();
    };
    const onUp = (x) => {
      if (!dragging) return;
      const dx = x - dragX;
      dragging = false;
      if (horizontal && Math.abs(dx) > THRESH) {
        go(dx < 0 ? index + 1 : index - 1);
      } else {
        start();
      }
    };

    // Mouse
    hero.addEventListener('mousedown', (e) => { onDown(e.clientX, e.clientY); });
    window.addEventListener('mousemove', (e) => onMove(e.clientX, e.clientY, e));
    window.addEventListener('mouseup', (e) => onUp(e.clientX));

    // Dokunmatik
    hero.addEventListener('touchstart', (e) => { const t = e.touches[0]; onDown(t.clientX, t.clientY); }, { passive: true });
    hero.addEventListener('touchmove', (e) => { const t = e.touches[0]; onMove(t.clientX, t.clientY, e); }, { passive: false });
    hero.addEventListener('touchend', (e) => { onUp((e.changedTouches[0] || {}).clientX || dragX); });

    // Suruklerken metin/gorsel secilmesin.
    hero.addEventListener('dragstart', (e) => e.preventDefault());

    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    const openForm = (id) => { const f = document.querySelector('[data-addr-form="' + CSS.escape(id) + '"]'); if (f) f.classList.remove('acc__hidden'); };
    const closeForm = (id) => { const f = document.querySelector('[data-addr-form="' + CSS.escape(id) + '"]'); if (f) f.classList.add('acc__hidden'); };
    document.querySelectorAll('[data-addr-toggle]').forEach((b) => b.addEventListener('click', () => openForm(b.getAttribute('data-addr-toggle'))));
    document.querySelectorAll('[data-addr-cancel]').forEach((b) => b.addEventListener('click', () => closeForm(b.getAttribute('data-addr-cancel'))));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    const loginView = document.querySelector('[data-login-view]');
    const recoverView = document.querySelector('[data-recover-view]');
    if (!loginView || !recoverView) return;
    const show = (recover) => {
      loginView.classList.toggle('acc__hidden', recover);
      recoverView.classList.toggle('acc__hidden', !recover);
    };
    // Sunucu recover formunu gonderince #recover ile geri doner -> acik goster.
    if (window.location.hash === '#recover') show(true);
    document.querySelectorAll('[data-recover-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); window.location.hash = 'recover'; show(true); }));
    document.querySelectorAll('[data-recover-close]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); window.location.hash = 'login'; show(false); }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["name-preview"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-name-preview]').forEach((root) => {
    const input = root.querySelector('[data-np-input]');
    const output = root.querySelector('[data-np-output]');
    const sr = root.querySelector('[data-np-sr]');
    const count = root.querySelector('[data-np-count]');
    if (!input || !output) return;

    const fallback = input.dataset.npFallback || '';

    const render = () => {
      const value = input.value.trim() || fallback;
      output.textContent = value;
      if (sr) sr.textContent = value;
      if (count) count.textContent = input.value.length;
    };

    input.addEventListener('input', render);
    render();

    // Metal secici
    const swatches = [...root.querySelectorAll('[data-np-metal]')];
    swatches.forEach((btn) => {
      btn.addEventListener('click', () => {
        root.style.setProperty('--np-metal', btn.dataset.npMetal);
        swatches.forEach((b) => {
          const on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    });

    // Yazi stili secici
    const fonts = [...root.querySelectorAll('[data-np-font]')];
    fonts.forEach((btn) => {
      btn.addEventListener('click', () => {
        root.style.setProperty('--np-font-active', btn.dataset.npFont);
        fonts.forEach((b) => {
          const on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-modal"]) return;
  try {
    
  document.querySelectorAll('[data-nlm]').forEach((modal) => {
    const KEY = 'akik:nlm-seen';
    const delay = parseInt(modal.dataset.delay || '3000', 10);
    const days = parseInt(modal.dataset.days || '30', 10);
    let lastFocus = null;

    const lockScroll = (on) => {
      document.documentElement.style.overflow = on ? 'hidden' : '';
    };

    const markSeen = () => {
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    };

    const open = () => {
      lastFocus = document.activeElement;
      modal.hidden = false;
      requestAnimationFrame(() => modal.classList.add('is-open'));
      lockScroll(true);
      modal.querySelector('.nlm__input, [data-nlm-close]')?.focus();
    };

    const close = () => {
      markSeen();
      modal.classList.remove('is-open');
      lockScroll(false);
      const done = () => {
        modal.hidden = true;
        modal.removeEventListener('transitionend', done);
      };
      modal.addEventListener('transitionend', done);
      setTimeout(() => { if (!modal.classList.contains('is-open')) modal.hidden = true; }, 600);
      lastFocus?.focus();
    };

    // Form gonderiminden sonra sayfa yeniden yuklenir; sonuc notu varsa modal'i
    // hemen ac ki kullanici tesekkur/hata mesajini gorsun.
    const result = modal.querySelector('[data-nlm-result]');
    if (result) {
      open();
      if (result.classList.contains('nlm__note--ok')) markSeen();
    } else {
      // Ilk ziyaret mantigi: son gorulme uzerinden N gun gectiyse (ya da hic
      // gorulmediyse) kisa bir gecikmeyle ac.
      let last = 0;
      try { last = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
      const elapsed = Date.now() - last;
      if (!last || elapsed > days * 86400000) {
        setTimeout(open, delay);
      }
    }

    modal.querySelectorAll('[data-nlm-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  document.querySelectorAll('.page [data-open-chat]').forEach((b) => {
    b.addEventListener('click', () => {
      window.dispatchEvent(new CustomEvent('akik:open-chat', { detail: { source: 'page' } }));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-carousel]').forEach((root) => {
    const track = root.querySelector('[data-carousel-track]');
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    const bar = root.querySelector('[data-carousel-bar]');
    if (!track) return;

    // Bir adim = gorunur alanin genisligi. Sabit bir kart sayisi yerine
    // gorunur genisligi kullanmak, kac kart gosterildiginden bagimsiz olarak
    // her zaman "bir ekran" kaydirir.
    const step = () => track.clientWidth;

    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      const x = track.scrollLeft;

      // 1px tolerans: tarayicilar kesirli piksel dondurdugu icin tam esitlik
      // aramak, sonda butonun aktif kalmasina yol acar.
      if (prev) prev.disabled = x <= 1;
      if (next) next.disabled = x >= max - 1;

      if (bar && max > 0) {
        const visible = track.clientWidth / track.scrollWidth;
        bar.style.width = `${visible * 100}%`;
        bar.style.transform = `translateX(${(x / max) * ((1 / visible) - 1) * 100}%)`;
      }
    };

    prev?.addEventListener('click', () => track.scrollBy({ left: -step() }));
    next?.addEventListener('click', () => track.scrollBy({ left: step() }));

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();

    // --- Otomatik kaydirma (kendi kendine slide) ---
    if (root.dataset.autoplay === '1') {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const speed = parseFloat(root.dataset.autoSpeed) || 0.6; // px / frame (~60fps)
      let paused = false, raf = 0;
      const maxX = () => track.scrollWidth - track.clientWidth;
      const tick = () => {
        if (!paused && maxX() > 2) {
          if (track.scrollLeft >= maxX() - 1) {
            track.scrollTo({ left: 0, behavior: 'auto' }); // basa sar (dongu)
          } else {
            track.scrollLeft += speed;
          }
        }
        raf = requestAnimationFrame(tick);
      };
      // Etkilesimde durakla (hover / dokunma / surukleme).
      const pause = () => { paused = true; };
      const resume = () => { paused = false; };
      root.addEventListener('mouseenter', pause);
      root.addEventListener('mouseleave', resume);
      root.addEventListener('touchstart', pause, { passive: true });
      root.addEventListener('touchend', () => setTimeout(resume, 1200), { passive: true });
      root.addEventListener('pointerdown', pause);
      window.addEventListener('pointerup', () => setTimeout(resume, 1200));
      // Ekranda gorunurken calis (performans).
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((e) => { paused = !e[0].isIntersecting; }, { threshold: 0.05 }).observe(root);
      }
      if (!reduce) raf = requestAnimationFrame(tick);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ptabs]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[data-ptab]')];
    const panels = [...root.querySelectorAll('[data-ptab-panel]')];
    const prev = root.querySelector('[data-ptab-prev]');
    const next = root.querySelector('[data-ptab-next]');
    const bar = root.querySelector('[data-ptab-bar]');

    const activeTrack = () =>
      root.querySelector('.ptabs__panel.is-active [data-ptab-track]');

    // Ilerleme cizgisini ve oklarin aktif/pasif durumunu aktif rayin kaydirma
    // konumuna gore gunceller.
    const sync = () => {
      const track = activeTrack();
      if (!track) return;
      const max = track.scrollWidth - track.clientWidth;
      const x = track.scrollLeft;

      if (prev) prev.disabled = x <= 1;
      if (next) next.disabled = x >= max - 1;

      if (bar && max > 0) {
        const visible = track.clientWidth / track.scrollWidth;
        bar.style.width = `${visible * 100}%`;
        bar.style.transform = `translateX(${(x / max) * ((1 / visible) - 1) * 100}%)`;
      } else if (bar) {
        bar.style.width = '100%';
        bar.style.transform = 'translateX(0)';
      }
    };

    const selectTab = (index) => {
      tabs.forEach((t) => {
        const on = t.dataset.ptab === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach((p) => {
        const on = p.dataset.ptabPanel === index;
        p.classList.toggle('is-active', on);
        p.hidden = !on;
      });
      // Sekme degisince ilerleme sifirlanmali; yeni ray farkli genislikte.
      sync();
    };

    tabs.forEach((tab) => tab.addEventListener('click', () => selectTab(tab.dataset.ptab)));

    // Oklar aktif rayi bir "ekran" kaydirir.
    prev?.addEventListener('click', () => {
      const t = activeTrack();
      if (t) t.scrollBy({ left: -t.clientWidth });
    });
    next?.addEventListener('click', () => {
      const t = activeTrack();
      if (t) t.scrollBy({ left: t.clientWidth });
    });

    // Her rayin kaydirilmasi ilerlemeyi gunceller (aktif olan yansir).
    root.querySelectorAll('[data-ptab-track]').forEach((track) => {
      track.addEventListener('scroll', sync, { passive: true });
    });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  // --- Kargo geri sayimi: GUNE gore son siparis saati ---
  // Hafta ici (Pzt-Cum): cutoff-h/m. Cumartesi: cutoff-h/m-sat. Pazar: ayni gun
  // kargo yok (ayarla kapatilabilir) -> "Yarin kargoda".
  document.querySelectorAll('[data-ship]').forEach((el) => {
    const out = el.querySelector('[data-ship-text]');
    const ch = parseInt(el.dataset.cutoffH, 10);
    const cm = parseInt(el.dataset.cutoffM, 10) || 0;
    if (!out || isNaN(ch)) { el.hidden = true; return; }
    // Cumartesi kesim (bos ise hafta ici degerine duser).
    const satH = el.dataset.cutoffHSat !== '' && el.dataset.cutoffHSat != null ? parseInt(el.dataset.cutoffHSat, 10) : ch;
    const satM = el.dataset.cutoffMSat !== '' && el.dataset.cutoffMSat != null ? (parseInt(el.dataset.cutoffMSat, 10) || 0) : cm;
    const sundayOn = el.dataset.sunday === 'true';

    const fmt = (mins) => {
      const h = Math.floor(mins / 60);
      const m = mins % 60;
      if (h > 0 && m > 0) return h + ' saat ' + m + ' dk';
      if (h > 0) return h + ' saat';
      return m + ' dk';
    };

    const render = () => {
      const now = new Date();
      const day = now.getDay(); // 0=Pazar, 6=Cumartesi
      let h = ch, m = cm, sameDay = true;
      if (day === 6) { h = satH; m = satM; }         // Cumartesi
      else if (day === 0 && !sundayOn) { sameDay = false; } // Pazar: ayni gun yok

      if (sameDay) {
        const cutoff = new Date();
        cutoff.setHours(h, m, 0, 0);
        const diffMin = Math.floor((cutoff - now) / 60000);
        if (diffMin > 0) {
          out.innerHTML = '<strong>' + fmt(diffMin) + '</strong> içinde kargoda';
          return;
        }
      }
      out.textContent = 'Yarın kargoda';
    };
    render();
    // Dakika basi guncelle (canli geri sayim hissi).
    setInterval(render, 30000);
  });

  // --- 360° interaktif cevirme: video karesini surukleyerek ilerlet ---
  // Otomatik oynatmak yerine kullanici yatay surukledikce video.currentTime
  // orantili degisir. Birakinca ATALET (momentum) ile yavasca donmeye devam
  // eder -> pruzsuz, premium his. Seek'ler rAF ile senkronlanir.
  document.querySelectorAll('[data-spin]').forEach((spin) => {
    const video = spin.querySelector('video');
    if (!video) return;
    video.pause();

    let duration = 0;
    const readDur = () => { if (!duration && video.duration) duration = video.duration; };
    readDur();
    video.addEventListener('loadedmetadata', readDur);

    const SENS = 1.15;       // tam genislik surukleme ~ 1.15 tur
    const FRICTION = 0.94;   // atalet sonumlemesi (frame basi)
    const MIN_V = 0.0004;    // atalet durma esigi (saniye/ms)

    let primed = false;
    let dragging = false;
    let vt = 0;              // sanal zaman (saniye; duration disina cikabilir)
    let vel = 0;             // hiz (saniye/ms) -> atalet
    let startX = 0, startVT = 0;
    let lastVT = 0, lastT = 0;
    let raf = null, seekPending = false;

    const prime = () => {
      // Bazi tarayicilar oynatilmadan kareyi decode etmez; ilk temasta kilidi ac.
      if (primed) return;
      primed = true;
      const p = video.play();
      if (p && p.then) p.then(() => video.pause()).catch(() => { primed = false; });
      else video.pause();
    };

    const seek = () => {
      if (!duration) return;
      let t = vt % duration;
      if (t < 0) t += duration;
      try { video.currentTime = t; } catch (e) {}
    };

    const frame = () => {
      raf = null;
      if (!dragging && Math.abs(vel) > MIN_V) {
        vt += vel * 16;      // atalet: son hizla ilerlet
        vel *= FRICTION;     // yavasca sonumle
        seek();
        raf = requestAnimationFrame(frame);
      } else if (seekPending) {
        seekPending = false;
        seek();
      }
    };
    const kick = () => { if (raf == null) raf = requestAnimationFrame(frame); };

    // --- Ogretici acilis animasyonu: gorunur olunca urun sag-sol salinir ---
    // Kullaniciya "bu doner" hissini verir; sonumlenerek 0'a oturur. Kullanici
    // dokununca aninda iptal olur ve bir daha oynamaz.
    const INTRO_DUR = 2600;    // ms
    const INTRO_SWEEP = 0.13;  // duration orani (~47°)
    const INTRO_CYCLES = 1.5;  // sag-sol salinim
    let introDone = false;
    let introRaf = null;
    let introStart = null;
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const cancelIntro = () => {
      introDone = true;
      if (introRaf) { cancelAnimationFrame(introRaf); introRaf = null; }
    };
    const introFrame = (ts) => {
      if (dragging || introDone) { introRaf = null; return; }
      if (introStart == null) introStart = ts;
      const p = (ts - introStart) / INTRO_DUR;
      if (p >= 1 || !duration) {
        vt = 0; seek();
        introRaf = null; introDone = true;
        return;
      }
      const damp = 1 - p;  // sonumlenerek 0'a
      vt = Math.sin(p * Math.PI * 2 * INTRO_CYCLES) * INTRO_SWEEP * duration * damp;
      seek();
      introRaf = requestAnimationFrame(introFrame);
    };
    let dragHideSet = false;
    const hideDragSoon = () => {
      // Surukle-ipucu (el+oklar) bir sure sonra kaybolur; 360 rozeti KALIR.
      if (dragHideSet) return;
      dragHideSet = true;
      setTimeout(() => { spin.classList.add('is-touched'); }, 7000);
    };
    const startIntro = () => {
      if (introDone) return;
      hideDragSoon();
      if (reduceMotion) { introDone = true; return; }
      readDur();
      if (!duration) { video.addEventListener('loadedmetadata', startIntro, { once: true }); return; }
      prime();
      // Decode'un ilk kareyi hazirlamasi icin kisa bekleme, sonra salin.
      setTimeout(() => {
        if (introDone || dragging) return;
        introStart = null;
        introRaf = requestAnimationFrame(introFrame);
      }, 200);
    };

    // Sadece gorunur olunca ve bir kez calis.
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((ents) => {
        ents.forEach((en) => {
          if (en.isIntersecting && en.intersectionRatio >= 0.5) {
            startIntro();
            io.disconnect();
          }
        });
      }, { threshold: [0, 0.5, 1] });
      io.observe(spin);
    } else {
      startIntro();
    }

    // YON KILIDI: dokunusa hemen "spin" demeyiz. Once yatay/dikey karari
    // verilir. DIKEY hareket -> sayfa serbestce kayar (capture/preventDefault
    // YOK). Sadece YATAY hareket spin'i kilitler. Boylece 360 gorselin uzerinde
    // asagi-yukari kaydirma takilmaz.
    let pointerActive = false;
    let axis = null;   // null | 'x' | 'y'
    let sx = 0, sy = 0;
    const LOCK = 8;    // yon kilidi esigi (px)

    const down = (e) => {
      readDur();
      if (!duration) return;
      pointerActive = true;
      axis = null;
      sx = e.clientX;
      sy = e.clientY;
      // Not: burada capture/preventDefault YOK -> dikey kaydirma serbest.
    };
    const move = (e) => {
      if (!pointerActive) return;
      const dxAbs = Math.abs(e.clientX - sx);
      const dyAbs = Math.abs(e.clientY - sy);

      if (axis == null) {
        if (dxAbs < LOCK && dyAbs < LOCK) return;   // yon henuz belirsiz
        if (dyAbs > dxAbs) {                          // DIKEY -> sayfa kaysin
          axis = 'y';
          pointerActive = false;
          return;
        }
        // YATAY -> spin'i kilitle
        axis = 'x';
        cancelIntro();
        prime();
        dragging = true;
        vel = 0;
        startX = e.clientX;   // sicramayi onle: kilit anindaki x
        startVT = vt;
        lastVT = vt;
        lastT = performance.now();
        spin.classList.add('is-dragging', 'is-touched');
        try { spin.setPointerCapture(e.pointerId); } catch (e2) {}
      }

      if (axis !== 'x') return;

      e.preventDefault();
      const w = spin.clientWidth || 1;
      const dx = e.clientX - startX;
      vt = startVT + (dx / w) * SENS * duration;
      // Anlik hizi yumusatarak sakla (birakinca atalet icin).
      const now = performance.now();
      const ddt = now - lastT;
      if (ddt > 0) {
        const instV = (vt - lastVT) / ddt;
        vel = vel * 0.7 + instV * 0.3;
        lastVT = vt;
        lastT = now;
      }
      seekPending = true;
      kick();
    };
    const up = (e) => {
      pointerActive = false;
      if (axis !== 'x' || !dragging) { axis = null; return; }
      dragging = false;
      axis = null;
      spin.classList.remove('is-dragging');
      try { spin.releasePointerCapture(e.pointerId); } catch (e2) {}
      kick();  // atalet baslasin
    };

    spin.addEventListener('pointerdown', down);
    spin.addEventListener('pointermove', move);
    spin.addEventListener('pointerup', up);
    spin.addEventListener('pointercancel', up);
  });

  // --- Tam ekran gorsel (lightbox) ---
  // Galeri gorseline tiklayinca tam ekran acilir; yatay kaydirarak/oklarla
  // diger gorsele gecilir; X / Escape / arka plan ile kapanir.
  (function () {
    const lb = document.querySelector('[data-lightbox]');
    if (!lb) return;
    const track = lb.querySelector('[data-lightbox-track]');
    const slides = [...lb.querySelectorAll('.pdp__lightbox-slide')];
    const curEl = lb.querySelector('[data-lightbox-current]');
    const openers = [...document.querySelectorAll('.pdp__gallery [data-lightbox-open]')];
    if (!track || !slides.length) return;

    const idx = () => Math.round(track.scrollLeft / track.clientWidth);
    const clamp = (i) => Math.min(Math.max(i, 0), slides.length - 1);
    const goTo = (i, smooth) => track.scrollTo({ left: track.clientWidth * clamp(i), behavior: smooth ? 'smooth' : 'auto' });
    const updateCount = () => { if (curEl) curEl.textContent = idx() + 1; };

    const open = (i) => {
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('lb-open');
      requestAnimationFrame(() => {
        lb.classList.add('is-open');
        goTo(i, false);
        updateCount();
      });
    };
    const close = () => {
      lb.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('lb-open');
      setTimeout(() => { lb.hidden = true; }, 260);
    };

    openers.forEach((el, i) => {
      el.addEventListener('click', (e) => {
        // Galeri suruklemesinden sonra acilmasin (drag click'i preventDefault eder).
        if (e.defaultPrevented) return;
        open(i);
      });
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i); }
      });
    });

    lb.querySelectorAll('[data-lightbox-close]').forEach((b) => b.addEventListener('click', close));
    const prevBtn = lb.querySelector('[data-lightbox-prev]');
    const nextBtn = lb.querySelector('[data-lightbox-next]');
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(idx() - 1, true));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(idx() + 1, true));
    track.addEventListener('scroll', () => window.requestAnimationFrame(updateCount), { passive: true });
    // Arka plana (gorsel disi) tiklayinca kapat.
    track.addEventListener('click', (e) => {
      if (e.target === track || e.target.classList.contains('pdp__lightbox-slide')) close();
    });
    document.addEventListener('keydown', (e) => {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') goTo(idx() + 1, true);
      else if (e.key === 'ArrowLeft') goTo(idx() - 1, true);
    });
  })();

  document.querySelectorAll('.pdp').forEach((pdp) => {
    // --- "Su an X kisi inceliyor" (aciliyet hissi) ---
    // Urune gore tohumlu, saatlik degisen taban + hafif dalgalanma. Gercek veri
    // degildir; magazacilikta yaygin sosyal kanit ogesi.
    // Birden fazla yerde olabilir (masaustu teslimat kutusu + mobil statu satiri);
    // ayni tohumla ayni sayiyi gosterirler.
    (function () {
      const els = [...pdp.querySelectorAll('[data-viewers]')];
      if (!els.length) return;
      const first = els[0];
      const min = parseInt(first.dataset.min, 10) || 8;
      const max = Math.max(min, parseInt(first.dataset.max, 10) || 40);
      const outs = els.map((el) => el.querySelector('[data-viewers-count]')).filter(Boolean);
      // Tohum: urun id + gunun saati -> ayni saatte ayni urun tutarli, saat basi kayar.
      const seed = (parseInt(first.dataset.seed, 10) || 1) + Math.floor(Date.now() / 3600000);
      const rand = (s) => { const x = Math.sin(s) * 10000; return x - Math.floor(x); };
      let n = min + Math.floor(rand(seed) * (max - min + 1));
      const set = (v) => { n = Math.max(min, Math.min(max, v)); outs.forEach((o) => { o.textContent = n; }); };
      set(n);
      els.forEach((el) => { el.hidden = false; });
      setInterval(() => {
        const step = 1 + Math.floor(Math.random() * 2);
        set(n + (Math.random() < 0.5 ? -step : step));
      }, 6000 + Math.random() * 7000);
    })();

    // --- 'Kisi inceliyor' toast (mobil, kalp altinda): gecikmeyle belir, biraz kal,
    //     animasyonla git; periyodik tekrar eder. ---
    (function () {
      const vToast = pdp.querySelector('[data-viewers-toast]');
      if (!vToast || !vToast.querySelector('[data-viewers]')) return;
      const ping = () => {
        vToast.classList.add('is-shown');
        setTimeout(() => vToast.classList.remove('is-shown'), 5200);
      };
      setTimeout(() => { ping(); setInterval(ping, 26000); }, 4200);
    })();

    // --- Artistik olcu dropdown'i (kisiye ozel): ac/kapat + secim -> gizli radio ---
    (function () {
      const dds = [...pdp.querySelectorAll('[data-dd]')];
      if (!dds.length) return;
      const close = (dd) => {
        dd.removeAttribute('data-open');
        const b = dd.querySelector('[data-dd-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      };
      const closeAll = (except) => dds.forEach((dd) => { if (dd !== except) close(dd); });
      dds.forEach((dd) => {
        const btn = dd.querySelector('[data-dd-toggle]');
        const menu = dd.querySelector('[data-dd-menu]');
        const valEl = dd.querySelector('[data-dd-value]');
        const fs = dd.closest('.pdp__option') || dd.closest('fieldset');
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const isOpen = dd.hasAttribute('data-open');
          closeAll(dd);
          if (isOpen) { close(dd); }
          else { dd.setAttribute('data-open', ''); btn.setAttribute('aria-expanded', 'true'); }
        });
        menu.addEventListener('click', (e) => {
          const opt = e.target.closest('[data-dd-opt]');
          if (!opt || opt.classList.contains('is-soldout')) return;
          const value = opt.getAttribute('data-dd-opt');
          if (fs) {
            const radio = [...fs.querySelectorAll('input[data-option-input]')].find((r) => r.value === value);
            if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
          }
          const lbl = opt.querySelector('.pdp__dd-opt-label');
          if (valEl) { valEl.textContent = lbl ? lbl.textContent : value; valEl.classList.remove('pdp__dd-current--ph'); }
          menu.querySelectorAll('.pdp__dd-opt').forEach((o) => {
            const on = o === opt;
            o.classList.toggle('is-selected', on);
            o.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          close(dd);
        });
      });
      document.addEventListener('click', (e) => { if (!e.target.closest('[data-dd]')) closeAll(null); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(null); });
    })();

    // --- Olcu secme modali: olcu secmeden "Sepete Ekle"ye basilinca acilir ---
    // Secilmemis secenek gruplarini (genelde olcu) sayfadaki gizli radio'lardan
    // kurar; secim ayni radio/select'e yazilir, varyant guncellenince form gonderilir.
    const openSizeModal = () => {
      const groups = [...pdp.querySelectorAll('.pdp__option')].filter((fs) =>
        !fs.hidden && fs.querySelector('[data-option-input]') && !fs.querySelector('[data-option-input]:checked'));
      if (!groups.length) return;
      const escH = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const titleTxt = (pdp.querySelector('.pdp__title') || {}).textContent || '';
      const hasGuide = !!pdp.querySelector('[data-sizeguide-open]');
      const picks = {};
      const modal = document.createElement('div');
      modal.className = 'szm';
      modal.setAttribute('lang', 'tr');
      modal.innerHTML = `
        <div class="szm__backdrop" data-szm-close></div>
        <div class="szm__panel" role="dialog" aria-modal="true" aria-labelledby="SzmTitle">
          <span class="szm__grab" aria-hidden="true"></span>
          <button type="button" class="szm__close" data-szm-close aria-label="Kapat">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>
          </button>
          <p class="szm__eyebrow">Ölçü seçin</p>
          <h2 class="szm__title" id="SzmTitle">${escH(titleTxt.trim())}</h2>
          ${groups.map((fs, gi) => {
            const inputs = [...fs.querySelectorAll('[data-option-input]')];
            const name = inputs[0].name;
            const legend = (fs.querySelector('.pdp__option-name') || fs.querySelector('legend') || {}).textContent || '';
            const label = legend.split(':')[0].trim();
            const isColor = fs.classList.contains('pdp__option--color');
            return `<div class="szm__group" data-szm-group="${escH(name)}">
              <div class="szm__ghead"><span>${escH(label)}</span>${gi === 0 && hasGuide && fs.classList.contains('pdp__option--size') ? '<button type="button" class="szm__guide" data-szm-guide>Ölçü Rehberi</button>' : ''}</div>
              <div class="szm__chips${isColor ? ' szm__chips--color' : ''}">${inputs.map((inp) => {
                const lab = fs.querySelector('label[for="' + inp.id + '"]');
                const out = !!(lab && lab.classList.contains('pdp__swatch--soldout'));
                const sw = isColor && lab ? lab.style.getPropertyValue('--sw') : '';
                return `<button type="button" class="szm__chip${out ? ' is-out' : ''}" data-szm-val="${escH(inp.value)}" aria-pressed="false"${out ? ' disabled' : ''}>${sw ? `<i style="--sw:${escH(sw)}"></i>` : ''}<span>${escH(inp.value)}</span></button>`;
              }).join('')}</div>
            </div>`;
          }).join('')}
          <p class="szm__msg" data-szm-msg hidden></p>
          <button type="button" class="btn btn--primary szm__add" data-szm-add disabled>Ölçü seçin</button>
        </div>`;
      document.body.appendChild(modal);
      const addB = modal.querySelector('[data-szm-add]');
      const msg = modal.querySelector('[data-szm-msg]');
      const prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      // Sohbet botu (#akik-bot, en ustte sabit) modalin uzerine binmesin.
      document.documentElement.classList.add('szm-open');
      requestAnimationFrame(() => modal.classList.add('is-open'));
      const firstChip = modal.querySelector('.szm__chip:not([disabled])');
      if (firstChip) setTimeout(() => firstChip.focus({ preventScroll: true }), 60);

      const close = () => {
        modal.classList.remove('is-open');
        document.documentElement.style.overflow = prevOverflow;
        document.documentElement.classList.remove('szm-open');
        document.removeEventListener('keydown', onKey);
        setTimeout(() => modal.remove(), 300);
      };
      const onKey = (e) => { if (e.key === 'Escape') close(); };
      document.addEventListener('keydown', onKey);

      modal.addEventListener('click', async (e) => {
        if (e.target.closest('[data-szm-close]')) { close(); return; }
        if (e.target.closest('[data-szm-guide]')) {
          close();
          const g = pdp.querySelector('[data-sizeguide-open]');
          if (g) setTimeout(() => g.click(), 320);
          return;
        }
        const chip = e.target.closest('[data-szm-val]');
        if (chip && !chip.disabled) {
          const grp = chip.closest('[data-szm-group]');
          grp.querySelectorAll('[data-szm-val]').forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
          picks[grp.dataset.szmGroup] = chip.dataset.szmVal;
          msg.hidden = true;
          const done = Object.keys(picks).length === groups.length;
          addB.disabled = !done;
          addB.textContent = done ? 'Sepete Ekle' : 'Ölçü seçin';
          return;
        }
        if (e.target.closest('[data-szm-add]') && !addB.disabled) {
          addB.disabled = true;
          // Secimi sayfadaki secicilere yaz (select varsa onun uzerinden; o radio'yu da isaretler).
          Object.entries(picks).forEach(([name, val]) => {
            const idx = name.replace('option-', '');
            const sel = pdp.querySelector('[data-size-select][data-opt-idx="' + idx + '"]');
            if (sel) {
              sel.value = val;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              const wrap = sel.closest('[data-sizesel]');
              if (wrap) wrap.classList.remove('pdp__sizesel--empty');
            } else {
              const radio = [...pdp.querySelectorAll('input[name="' + name + '"]')].find((r) => r.value === val);
              if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
            }
          });
          // Varyant (gizli id) guncellenene kadar bekle, sonra normal ekleme akisi.
          const data = await loadProduct();
          const selected = [...pdp.querySelectorAll('[data-option-input]')].filter((i) => i.checked)
            .sort((a, b) => a.name.localeCompare(b.name)).map((i) => i.value);
          const v = data && data.variants.find((x) => x.options.every((o, i) => o === selected[i]));
          if (!v || !v.available) {
            msg.textContent = 'Bu seçim şu an stokta yok. Lütfen başka bir ölçü seçin.';
            msg.hidden = false;
            return;
          }
          const t0 = Date.now();
          while (variantInput && variantInput.value !== String(v.id) && Date.now() - t0 < 2000) {
            await new Promise((r) => setTimeout(r, 40));
          }
          close();
          if (addForm.requestSubmit) addForm.requestSubmit(); else addForm.dispatchEvent(new Event('submit', { cancelable: true }));
        }
      });
    };

    // --- Sepete ekle: AJAX + onay modali (sepete gitmeden) ---
    const addForm = pdp.querySelector('.pdp__form') || document.querySelector('.pdp__form');
    const addModal = document.querySelector('[data-add-modal]');
    if (addForm && addModal) {
      let hideTimer = null;
      // Eklenen TUM urunleri (ana + secili kutular) modalda liste olarak goster.
      const openAdd = (lines) => {
        clearTimeout(hideTimer);
        const list = addModal.querySelector('[data-add-lines]');
        const titleEl = addModal.querySelector('[data-add-title]');
        if (list) {
          list.innerHTML = '';
          lines.forEach((it) => {
            const row = document.createElement('div');
            row.className = 'addmodal__line';
            const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_100x$1$2') : '';
            const variant = (it.variant && it.variant !== 'Default Title') ? it.variant : '';
            const sub = it.sub || '';
            row.innerHTML =
              (img ? '<img class="addmodal__thumb" src="' + img + '" alt="" width="56" height="56">' : '<span class="addmodal__thumb"></span>') +
              '<div class="addmodal__meta"><span class="addmodal__name"></span>' +
              (variant ? '<span class="addmodal__variant"></span>' : '') +
              (sub ? '<span class="addmodal__sub"></span>' : '') + '</div>';
            row.querySelector('.addmodal__name').textContent = it.title || '';
            if (variant) row.querySelector('.addmodal__variant').textContent = variant;
            if (sub) row.querySelector('.addmodal__sub').textContent = sub;
            list.appendChild(row);
          });
        }
        if (titleEl) titleEl.textContent = lines.length > 1 ? 'Ürünler sepete eklendi' : 'Ürün sepete eklendi';
        addModal.hidden = false;
        requestAnimationFrame(() => addModal.classList.add('is-open'));
        // "Sepete Git" hizli acilsin: sepet sayfasini simdiden arka planda hazirla.
        // Link ve on-yukleme AYNI benzersiz adres -> her eklemeden sonra guncel sepet.
        const goCart = addModal.querySelector('.addmodal__cart');
        const cartHref = (goCart ? goCart.pathname : '/cart') + '?r=' + Date.now();
        if (goCart) goCart.href = cartHref;
        const pf = document.createElement('link');
        pf.rel = 'prefetch'; pf.href = cartHref;
        document.head.appendChild(pf);
        document.documentElement.style.overflow = 'hidden';
      };
      const closeAdd = () => {
        addModal.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        hideTimer = setTimeout(() => { addModal.hidden = true; }, 300);
      };

      addForm.addEventListener('submit', (e) => {
        e.preventDefault();
        // OLCU ZORUNLU: tum secenekler secilmeden sepete EKLENMEZ. Secilmemisse
        // olcu secme modali acilir; secip "Sepete Ekle" deyince ekleme surer.
        const optInputs = [...pdp.querySelectorAll('[data-option-input]')];
        const optCount = new Set(optInputs.map((i) => i.name)).size;
        const selCount = optInputs.filter((i) => i.checked).length;
        if (optCount > 0 && selCount < optCount) {
          openSizeModal();
          return;
        }
        // Buton form'un DISINDA (form= ile bagli) -> pdp'den sec, addForm'dan degil.
        const btn = pdp.querySelector('[data-add-button]') || addForm.querySelector('[data-add-button]');
        const orig = btn ? btn.textContent : '';
        const loadStart = Date.now();
        const MIN_LOAD = 650; // spinner en az bu kadar gorunsun (kullanici fark etsin)
        if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.dataset.label = btn.textContent; btn.innerHTML = '<span class="pdp__btn-spin" aria-hidden="true"></span>Ekleniyor…'; }
        // Ayni anda sticky bar butonunu da yukleniyor goster.
        const stickyBtn = pdp.querySelector('[data-sticky-add]');
        if (stickyBtn && stickyBtn !== btn) { stickyBtn.disabled = true; stickyBtn.classList.add('is-loading'); stickyBtn.dataset.label = stickyBtn.textContent; stickyBtn.innerHTML = '<span class="pdp__btn-spin" aria-hidden="true"></span>Ekleniyor…'; }
        // Islem cok hizli bitse bile spinner MIN_LOAD kadar gorunsun.
        const afterMin = (fn) => { const el = MIN_LOAD - (Date.now() - loadStart); setTimeout(fn, Math.max(0, el)); };
        // Secili kutu onerileri (benzinli/benzinsiz) -> ana urunle birlikte eklenir.
        const checkedBoxes = [...pdp.querySelectorAll('[data-box-check]:checked')];
        const boxItems = checkedBoxes
          .map((cb) => ({ id: parseInt(cb.value, 10), quantity: 1 }))
          .filter((it) => it.id);
        // Modalda gosterilecek kutu satirlari (baslik + gorsel).
        const boxLines = checkedBoxes.map((cb) => ({
          image: cb.dataset.boxImage || '',
          title: cb.dataset.boxTitle || '',
          variant: ''
        }));
        // Ilave harf ucreti bilgisi (fee urunu ana urun EKLENDIKTEN sonra, ana
        // satirin KEY'ine baglanacak -> ayni urun 2 kez eklenince karismaz).
        const feePlans = [];
        pdp.querySelectorAll('[data-paidtext]').forEach((wrap) => {
          const feeId = parseInt(wrap.dataset.feeId, 10);
          const extra = parseInt(wrap.dataset.extra, 10) || 0;
          if (feeId && extra > 0) feePlans.push({ id: feeId, quantity: extra });
        });
        const updateCount = () => {
          fetch('/cart.js').then((r) => r.json()).then((cart) => {
            // Ilave harf ucreti satirlari (ana urunun alt kalemi) sayimda haric.
            const rc = (cart.items || []).reduce((s, i) => (((i.handle || '').indexOf('harf-ucreti') !== -1) ? s : s + i.quantity), 0);
            document.querySelectorAll('[data-cart-count]').forEach((el) => {
              if (el.classList.contains('mnav__count')) { el.textContent = rc; el.setAttribute('data-cart-count', rc); }
              else { el.textContent = '(' + rc + ')'; }
            });
          }).catch(() => {});
        };
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(addForm) })
          .then((r) => r.json())
          .then((item) => {
            if (item && (item.id || item.items)) {
              const line = item.items ? item.items[0] : item;
              // Girilen kisisellestirme (isim vb.) + ilave harf -> modalda alt bilgi.
              let subParts = [];
              const props = line.properties || {};
              Object.keys(props).forEach((k) => {
                if (k && k.charAt(0) !== '_' && props[k]) subParts.push(props[k]);
              });
              // Girilen kisisellestirme metni (sadece deger) — fee satirinda gosterilir.
              const persText = subParts.join(' · ');
              const totalExtra = feePlans.reduce((s, f) => s + (f.quantity || 0), 0);
              if (totalExtra > 0) subParts.push('+' + totalExtra + ' ilave harf');
              const mainLine = {
                image: line.image || (line.featured_image && line.featured_image.url) || '',
                title: line.product_title || line.title || '',
                variant: (line.variant_title && line.variant_title !== 'Default Title') ? line.variant_title : '',
                sub: subParts.join(' · ')
              };
              // Fee urunlerini ana satirin KEY'ine bagla (benzersiz).
              const extraItems = boxItems.slice();
              feePlans.forEach((f) => {
                // Gorunur ozellikler -> ODEME sayfasinda fee satiri kendini aciklar:
                // hangi urune ait + kac ilave harf. (_pid: sepette eslestirme icin gizli.)
                extraItems.push({
                  id: f.id,
                  quantity: f.quantity,
                  properties: Object.assign(
                    {
                      'Ürün': (line.product_title || '') + (line.variant_title && line.variant_title !== 'Default Title' ? ' · ' + line.variant_title : '')
                    },
                    persText ? { 'Kişiselleştirme': persText } : {},
                    {
                      'İlave harf': f.quantity + ' harf',
                      '_pid': String(line.key || '')
                    }
                  )
                });
              });
              const finish = () => afterMin(() => { openAdd([mainLine].concat(boxLines)); updateCount(); });
              if (extraItems.length) {
                // Kutu + harf ucretini ekle (ana urun property'leri korunur).
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ items: extraItems })
                }).then(finish).catch(finish);
              } else {
                finish();
              }
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(() => { window.location.href = '/cart'; })
          .finally(() => {
            afterMin(() => {
              if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = btn.dataset.label || orig; }
              if (stickyBtn && stickyBtn !== btn) { stickyBtn.disabled = false; stickyBtn.classList.remove('is-loading'); stickyBtn.textContent = stickyBtn.dataset.label || ''; }
            });
          });
      });

      addModal.querySelectorAll('[data-add-close], [data-add-continue]').forEach((b) => b.addEventListener('click', closeAdd));
      addModal.addEventListener('click', (e) => { if (e.target === addModal) closeAdd(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && addModal.classList.contains('is-open')) closeAdd(); });
    }

    // --- Sabit sepete ekle: biraz scroll yapinca belir (mobil) ---
    // --- Sabit Sepete Ekle cubugu: ana 'Sepete Ekle' gorunurden cikinca belir ---
    const stickyBar = document.querySelector('[data-pdp-sticky]');
    // Capa (her zaman layoutta) ustten gecince tetikler. Mobilde ana 'Sepete Ekle'
    // gizli oldugu icin dogrudan .pdp__buy'i gozlemek yerine capa kullaniyoruz.
    const buyRef = pdp.querySelector('[data-pdp-buy-anchor]') || pdp.querySelector('.pdp__buy');
    if (stickyBar && buyRef) {
      // Sticky gorunurken alt gezinme cubugunu da gizle (body sinifi).
      const setShown = (v) => {
        stickyBar.classList.toggle('is-visible', v);
        document.body.classList.toggle('pdp-sticky-on', v);
      };
      // Mobil: ACILISTA gizli (yalnizca mnav gorunur); cok az scroll yapinca
      //   (scrollY esigi) mnav'in uzerinde belirir. scrollY=0'da kesin gizli.
      // Masaustu: sepete ekle bolgesi (capa) ekran ustunden cikinca belirir.
      // Sayfa ici 'Sepete Ekle' (capa) ekranin ust kenarindan yukari cikinca
      // sticky belirir. Buton gorunurken sticky gizli -> erken/pat gelmez.
      let stickyRaf = 0;
      const evalSticky = () => {
        stickyRaf = 0;
        setShown(buyRef.getBoundingClientRect().top < 0);
      };
      const onStickyScroll = () => {
        if (stickyRaf) return;
        stickyRaf = requestAnimationFrame(evalSticky);
      };
      window.addEventListener('scroll', onStickyScroll, { passive: true });
      window.addEventListener('resize', onStickyScroll, { passive: true });
      evalSticky();
    }

    // --- Galeri gostergesi: track + kayan aktif segment (Zara tarzi) ---
    const gallery = pdp.querySelector('.pdp__gallery');
    const track = pdp.querySelector('[data-pdp-track]');
    const fill = pdp.querySelector('[data-pdp-fill]');
    if (gallery && track && fill) {
      const items = [...gallery.querySelectorAll('.pdp__media-item')];
      if (items.length > 1) {
        const n = items.length;
        let active = -1;
        // Video ilerleme cubugu gibi: bar soldan dolar. Kacinci gorseldeysek
        // o oranda dolu -> son gorselde tam dolu.
        const setActive = (i) => {
          i = Math.min(Math.max(i, 0), n - 1);
          if (i === active) return;
          active = i;
          fill.style.width = (((i + 1) / n) * 100) + '%';
        };
        setActive(0);
        const onScroll = () => {
          setActive(Math.round(gallery.scrollLeft / gallery.clientWidth));
        };
        gallery.addEventListener('scroll', () => {
          window.requestAnimationFrame(onScroll);
        }, { passive: true });

        // Web: fare ile surukleyerek kaydir.
        let down = false, startX = 0, startLeft = 0, moved = false;
        gallery.addEventListener('mousedown', (e) => {
          // 360° spin ogesinde galeri kaydirmasi calismasin (spin devralir).
          if (e.target.closest('[data-spin]')) return;
          down = true; moved = false; startX = e.pageX; startLeft = gallery.scrollLeft;
        });
        window.addEventListener('mousemove', (e) => {
          if (!down) return;
          const dx = e.pageX - startX;
          if (Math.abs(dx) > 4) moved = true;
          gallery.scrollLeft = startLeft - dx;
        });
        window.addEventListener('mouseup', () => {
          if (!down) return;
          down = false;
          // Surukleme bitince en yakin gorsele hizala.
          const idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
          gallery.scrollTo({ left: gallery.clientWidth * idx, behavior: 'smooth' });
        });
        // Surukleme sonrasi kazayla link tiklamasini engelle.
        gallery.addEventListener('click', (e) => { if (moved) { e.preventDefault(); moved = false; } }, true);
      }
    }

    // --- Mobil ust bar: geri ---
    const backBtn = pdp.querySelector('[data-pdp-back]');
    if (backBtn) {
      backBtn.addEventListener('click', () => {
        if (window.history.length > 1) window.history.back();
        else window.location.href = '/';
      });
    }
    // Favori (kalp) butonu artik global favori sistemiyle calisir (header.liquid).

    // --- Karakter sayaci ---
    pdp.querySelectorAll('[data-counter-input]').forEach((input) => {
      const out = input.closest('.pdp__field')?.querySelector('[data-counter-value]');
      if (!out) return;
      const sync = () => { out.textContent = input.value.length; };
      input.addEventListener('input', sync);
      sync();
    });

    // --- Isim (harf ucretli): canli ek ucret hesabi ---
    const fmtTL = (cents) => {
      try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: (pdp.dataset.currency || 'TRY'), maximumFractionDigits: 2 }).format(cents / 100); }
      catch (e) { return (cents / 100).toLocaleString('tr-TR') + ' ₺'; }
    };
    pdp.querySelectorAll('[data-paidtext]').forEach((wrap) => {
      const inp = wrap.querySelector('[data-paidtext-input]');
      const feeEl = wrap.querySelector('[data-paidtext-fee]');
      const free = parseInt(wrap.dataset.free, 10) || 0;
      const per = parseInt(wrap.dataset.per, 10) || 0; // TL
      const calc = () => {
        // Bosluklar haric harf sayisi.
        const len = (inp.value || '').replace(/\s/g, '').length;
        const extra = Math.max(0, len - free);
        const feeTL = extra * per;
        if (feeEl) feeEl.textContent = fmtTL(feeTL * 100);
        wrap.classList.toggle('is-charged', feeTL > 0);
        wrap.dataset.extra = extra;
        // Harf secenegi varsa: yazilan isme gore dogru varyanti sec (fiyat
        // varyanttan gelir). Deger adlari: "<free> harfe kadar" / "<len> harf".
        // Bicim farklarina (buyuk harf/bosluk) dayanikli: sayilari ayristir.
        const radios = [...pdp.querySelectorAll('[data-letter-option] input[data-option-input]')];
        const tiers = radios
          .map((r) => {
            const m = (r.value || '').match(/\d+/);
            return { r: r, n: m ? parseInt(m[0], 10) : null, upto: /kadar/i.test(r.value || '') };
          })
          .filter((t) => t.n !== null);
        if (tiers.length) {
          let pick = tiers.find((t) => !t.upto && t.n === len);
          if (!pick) {
            const covers = tiers.filter((t) => t.upto && len <= t.n).sort((a, b) => a.n - b.n);
            pick = covers[0];
          }
          if (!pick) {
            const le = tiers.filter((t) => t.n <= len).sort((a, b) => b.n - a.n);
            pick = le[0] || tiers.slice().sort((a, b) => a.n - b.n)[0];
          }
          if (pick && pick.r && !pick.r.checked && !pick.r.disabled) {
            pick.r.checked = true;
            pick.r.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      };
      inp.addEventListener('input', calc);
      calc();
    });

    // --- Resim/PDF yukleme: secilen dosya adini goster (kisiye ozel alan) ---
    pdp.querySelectorAll('[data-file-input]').forEach((inp) => {
      inp.addEventListener('change', () => {
        const wrap = inp.closest('.pdp__file');
        const txt = wrap && wrap.querySelector('[data-file-text]');
        const f = inp.files && inp.files[0];
        if (f) {
          if (wrap) wrap.classList.add('is-filled');
          if (txt) txt.textContent = f.name;
        } else if (wrap) {
          wrap.classList.remove('is-filled');
        }
      });
    });

    // --- Varyant secimi ---
    const variantInput = pdp.querySelector('[data-variant-id]');
    const optionInputs = [...pdp.querySelectorAll('[data-option-input]')];
    if (!variantInput || optionInputs.length === 0) return;

    const addBtn = pdp.querySelector('[data-add-button]');
    const priceEl = pdp.querySelector('[data-price]');

    // Stok durumu (varyanta gore guncellenir). Kaynak: gomulu JSON.
    // Birden fazla yerde olabilir (statu satiri + web'de fiyat yani) -> hepsi guncellenir.
    const stockRows = [...pdp.querySelectorAll('[data-stock]')];
    let stockMap = null;
    {
      const raw = pdp.querySelector('[data-variant-stock]');
      try { stockMap = raw ? JSON.parse(raw.textContent) : null; } catch (e) { stockMap = null; }
    }
    const lowTh = stockRows.length ? (parseInt(stockRows[0].dataset.low, 10) || 5) : 5;
    const setStock = (variantId) => {
      if (!stockMap) return;
      const s = stockMap[variantId];
      // Siparis uzerine (sinirsiz stok) varyant: "Magazada Bul" gizlenir. Gizlenen
      // magaza secenegi seciliyse adrese teslime don.
      const mto = !!(s && s.mto);
      pdp.classList.toggle('pdp--mto', mto);
      if (mto) {
        pdp.querySelectorAll('[data-store-trigger] input[type="radio"]:checked').forEach((r) => {
          r.closest('[data-delivery]')?.querySelector('input[value="ship"]')?.click();
        });
      }
      if (!stockRows.length) return;
      let cls = 'is-in', txt = 'Stokta Mevcut';
      if (!s || s.available === false) { cls = 'is-out'; txt = 'Tükendi'; }
      else if (s.tracked && s.inv === 1) { cls = 'is-critical'; txt = 'Son 1 Adet'; }
      else if (s.tracked && s.inv > 1 && s.inv <= lowTh) { cls = 'is-low'; txt = 'Tükenmek Üzere'; }
      else if (s.tracked && s.inv > lowTh) { cls = 'is-in'; txt = 'Stokta Mevcut'; }
      stockRows.forEach((row) => {
        row.classList.remove('is-in', 'is-low', 'is-out', 'is-critical');
        row.classList.add(cls);
        const t = row.querySelector('[data-stock-text]');
        if (t) t.textContent = txt;
      });
    };

    // Varyant -> gorsel senkronu (Liquid'den gomulu harita; ekstra istek yok).
    let variantMedia = {};
    try { variantMedia = JSON.parse(pdp.querySelector('[data-variant-media]')?.textContent || '{}'); } catch (e) {}
    const galleryEl = pdp.querySelector('.pdp__gallery');
    const syncImage = (variantId) => {
      if (!galleryEl) return;
      const mid = variantMedia[variantId];
      if (!mid) return; // varyanta gorsel atanmamis -> galeriyi oynatma
      const items = [...galleryEl.querySelectorAll('.pdp__media-item')];
      const idx = items.findIndex((it) => it.dataset.mediaId === String(mid));
      if (idx < 0) return;
      galleryEl.scrollTo({ left: idx * galleryEl.clientWidth, behavior: 'smooth' });
    };

    // Urun verisi bir kez cekilip saklanir: her secim degisiminde yeniden
    // istek atmak gereksiz gecikme yaratir.
    let productData = null;
    const loadProduct = async () => {
      if (productData) return productData;
      const res = await fetch(`${window.location.pathname}.js`);
      if (res.ok) productData = await res.json();
      return productData;
    };

    const money = (cents, currency) =>
      new Intl.NumberFormat('tr-TR', { style: 'currency', currency: currency || 'TRY' })
        .format(cents / 100);

    // Indirim %'sine gore renk kademesi (kartla ayni).
    // Indirim %'sine gore renk: tema ayarlarindan (data-disc-colors) gelir.
    // Yazi rengi arka planin parlakligina gore otomatik (koyu/beyaz).
    let discColors = {};
    try { discColors = JSON.parse((priceEl && priceEl.dataset.discColors) || '{}'); } catch (e) {}
    const offStyle = (off) => {
      let t = Math.floor(off / 10);
      if (t < 1) t = 1;
      if (t > 9) t = 9;
      const pair = discColors[t] || ['#000000', '#ffffff'];
      const bg = pair[0] || '#000000';
      const fg = pair[1] || '#ffffff';
      return `background:${bg};color:${fg};`;
    };

    const update = async () => {
      const data = await loadProduct();
      if (!data) return;

      // Secili degerleri secenek sirasina gore topla
      const selected = optionInputs
        .filter((i) => i.checked)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((i) => i.value);

      // Kac ayri secenek (olcu/renk...) var? Hepsi secilmeden sepete eklenemez.
      const optionCount = new Set(optionInputs.map((i) => i.name)).size;
      if (selected.length < optionCount) {
        const stAdd0 = document.querySelector('[data-sticky-add]');
        // Eksik secim: buton yine "Sepete Ekle"; basinca olcu secme modali acilir.
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Sepete Ekle'; }
        if (stAdd0) { stAdd0.disabled = false; stAdd0.textContent = 'Sepete Ekle'; }
        return;
      }

      const variant = data.variants.find((v) =>
        v.options.every((opt, idx) => opt === selected[idx])
      );

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Mevcut değil'; }
        return;
      }

      variantInput.value = variant.id;
      setStock(variant.id);
      syncImage(variant.id);
      // Taksit modalinin fiyat kaynagini varyanta gore guncelle.
      // Taksit hesabi kampanyali fiyattan (Akik Pazar yuzdesi varsa).
      const tkPct = Number(priceEl?.dataset.promoPct || 0);
      pdp.dataset.productPrice = tkPct > 0 ? Math.round(variant.price * (100 - tkPct) / 100) : variant.price;
      // AKIK taksit: fiyat alt sınırın altındaysa taksit düğmesini gizle
      pdp.querySelectorAll('[data-tax-open][data-tax-min]').forEach((b) => { b.hidden = variant.price < (parseInt(b.dataset.taxMin, 10) || 0); });

      // Stok kodu + barkod: varyanta gore guncelle (tum data-spec-* alanlari).
      const codesBox = pdp.querySelector('[data-codes]');
      // Varyant alani bossa metafield fallback (data-*-fallback) kullanilir.
      const skuVal = variant.sku || (codesBox && codesBox.dataset.skuFallback) || '';
      const barVal = variant.barcode || (codesBox && codesBox.dataset.barcodeFallback) || '';
      pdp.querySelectorAll('[data-spec-sku]').forEach((el) => { el.textContent = skuVal; });
      pdp.querySelectorAll('[data-spec-barcode]').forEach((el) => { el.textContent = barVal; });
      if (codesBox) {
        const skuWrap = codesBox.querySelector('.pdp__code--sku');
        const barWrap = codesBox.querySelector('.pdp__code--barcode');
        if (skuWrap) skuWrap.hidden = !skuVal;
        if (barWrap) barWrap.hidden = !barVal;
        const hasGuide = !!codesBox.querySelector('.pdp__code-guide');
        codesBox.hidden = !skuVal && !barVal && !hasGuide;
      }

      // Not: Olcu/varyant secilince adres cubuguna ?variant= YAZILMAZ. Boylece
      // sayfa yenilenince "Standart" olcu default kalir ve adres temiz durur.
      // Sepete giden olcu yukaridaki gizli input (variantInput.value) ile dogru.
      // Direkt ?variant=... linkleri yine dogru olcuyu acar (Liquid selected_variant).

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Sepete Ekle' : 'Tükendi';
      }

      // Sabit (sticky) cubuk: fiyat + buton senkronu.
      const stAdd = document.querySelector('[data-sticky-add]');
      if (stAdd) {
        stAdd.disabled = !variant.available;
        stAdd.textContent = variant.available ? 'Sepete Ekle' : 'Tükendi';
      }
      // Akik Pazar kampanyasi: fiyat alanlarinda indirimli fiyat (Liquid ile ayni hesap).
      const promoPct = Number(priceEl?.dataset.promoPct || 0);
      const pv = promoPct > 0
        ? { price: Math.round(variant.price * (100 - promoPct) / 100), compare_at_price: Math.max(variant.compare_at_price || 0, variant.price) }
        : variant;
      // akik-promo-live sepete gore yuzdeyi degistirince bu degerlerle yeniden hesaplar.
      if (priceEl && priceEl.dataset.promo) { priceEl.dataset.base = variant.price; priceEl.dataset.was = pv.compare_at_price; }
      const stPrice = document.querySelector('[data-sticky-price]');
      const stCamp = document.querySelector('[data-sticky-camp]');
      if (stPrice) {
        if (pv.compare_at_price > pv.price) {
          const soff = Math.round((pv.compare_at_price - pv.price) * 100 / pv.compare_at_price);
          stPrice.classList.add('pdp__sticky-price--sale');
          stPrice.innerHTML = `<span class="pdp__sticky-was">${money(pv.compare_at_price, data.currency)}</span>`
            + `<span class="pdp__sticky-now">${money(pv.price, data.currency)}</span>`
            + (soff > 0 ? `<span class="pdp__sticky-off" style="${offStyle(soff)}">%${soff}</span>` : '');
          if (stCamp) {
            stCamp.hidden = false;
            if (stCamp.hasAttribute('data-camp-match')) stCamp.style.cssText = offStyle(soff);
          }
        } else {
          stPrice.classList.remove('pdp__sticky-price--sale');
          stPrice.innerHTML = `<span class="pdp__sticky-now">${money(pv.price, data.currency)}</span>`;
          if (stCamp) stCamp.hidden = true;
        }
      }

      // Gelince Haber Ver: tukeninceye ozel goster; gizli mesaj govdesini guncelle.
      const notifyBtn = pdp.querySelector('[data-notify-open]');
      if (notifyBtn) notifyBtn.hidden = variant.available;
      const notifyBody = document.querySelector('[data-notify-body]');
      if (notifyBody) {
        const skuTxt = variant.sku ? ` (SKU: ${variant.sku})` : '';
        notifyBody.value = `Stok bildirimi talebi — ${data.title || ''} / ${variant.title || ''}${skuTxt}. Link: ${window.location.origin}${window.location.pathname}?variant=${variant.id}`;
      }

      if (priceEl) {
        if (pv.compare_at_price > pv.price) {
          const off = Math.round((pv.compare_at_price - pv.price) * 100 / pv.compare_at_price);
          priceEl.classList.add('pdp__price--sale');
          priceEl.innerHTML =
            `<span class="pdp__price-was">${money(pv.compare_at_price, data.currency)}</span>`
            + `<span class="pdp__price-now">${money(pv.price, data.currency)}</span>`
            + (off > 0 ? `<span class="pdp__price-off" data-price-off style="${offStyle(off)}">%${off}</span>` : '');
        } else {
          priceEl.classList.remove('pdp__price--sale');
          priceEl.innerHTML = `<span>${money(pv.price, data.currency)}</span>`;
        }
      }

      // Kampanya rozeti: indirimliyse goster; 'match' modda rengini % ile esitle.
      const campEl = pdp.querySelector('[data-campaign]');
      if (campEl) {
        const onSale = pv.compare_at_price > pv.price;
        campEl.style.display = onSale ? '' : 'none';
        if (onSale && campEl.hasAttribute('data-campaign-match')) {
          const coff = Math.round((pv.compare_at_price - pv.price) * 100 / pv.compare_at_price);
          const pair = discColors[Math.min(9, Math.max(1, Math.floor(coff / 10)))] || ['#F4E04D', '#1E1E1E'];
          campEl.style.background = pair[0] || '#F4E04D';
          campEl.style.color = pair[1] || '#1E1E1E';
        }
      }

      selected.forEach((val, idx) => {
        const label = pdp.querySelector(`[data-option-value="${idx}"]`);
        if (label) label.textContent = val;
      });
    };

    optionInputs.forEach((i) => i.addEventListener('change', update));

    // Mobil native olcu <select> -> ilgili gizli radio'yu isaretle + change tetikle.
    // Boylece varyant secimi (fiyat/stok/gorsel) mevcut mantikla guncellenir.
    pdp.querySelectorAll('[data-size-select]').forEach((sel) => {
      sel.addEventListener('change', () => {
        const idx = sel.getAttribute('data-opt-idx');
        const val = sel.value;
        const esc = (window.CSS && CSS.escape) ? CSS.escape(val) : val.replace(/"/g, '\\"');
        const radio = pdp.querySelector('input[name="option-' + idx + '"][value="' + esc + '"]');
        if (radio && !radio.disabled) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        // Kompakt gorunumdeki secili degeri de guncelle.
        const wrap = sel.closest('[data-sizesel]');
        const cur = wrap && wrap.querySelector('[data-sizesel-cur]');
        if (cur) cur.textContent = val;
      });
    });

    // Ilk yuklemede: secili varyantin gorseli zaten atanmissa ona hizala
    // (ekstra istek yok; sadece gomulu haritayi kullanir).
    if (variantInput.value) syncImage(variantInput.value);
  });

  // --- Mağazada Bul modalı ---
  const storeModal = document.querySelector('[data-store-modal]');
  if (storeModal) {
    let hideTimer = null;
    const open = () => {
      clearTimeout(hideTimer);
      storeModal.hidden = false;
      requestAnimationFrame(() => storeModal.classList.add('is-open'));
      document.documentElement.style.overflow = 'hidden';
    };
    const close = () => {
      storeModal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      hideTimer = setTimeout(() => { storeModal.hidden = true; }, 320);
    };
    document.querySelectorAll('[data-store-open]').forEach((b) => b.addEventListener('click', open));
    storeModal.querySelectorAll('[data-store-close]').forEach((b) => b.addEventListener('click', close));
    storeModal.addEventListener('click', (e) => { if (e.target === storeModal) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && storeModal.classList.contains('is-open')) close(); });

    // Canli destek: modali kapatip 'akik:open-chat' olayini tetikler.
    // Chatbot kurulunca bu olaya baglanip pencereyi acabilirsiniz.
    storeModal.querySelectorAll('[data-open-chat]').forEach((b) => {
      b.addEventListener('click', () => {
        close();
        window.dispatchEvent(new CustomEvent('akik:open-chat', { detail: { source: 'store-modal' } }));
      });
    });
  }

  // --- Gelince Haber Ver modalı (stok bildirimi) ---
  const notifyModal = document.querySelector('[data-notify-modal]');
  if (notifyModal) {
    let nHide = null;
    const nOpen = () => {
      clearTimeout(nHide);
      notifyModal.hidden = false;
      requestAnimationFrame(() => notifyModal.classList.add('is-open'));
      document.documentElement.style.overflow = 'hidden';
      const inp = notifyModal.querySelector('input[type="email"]');
      if (inp) setTimeout(() => inp.focus(), 120);
    };
    const nClose = () => {
      notifyModal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      nHide = setTimeout(() => { notifyModal.hidden = true; }, 320);
    };
    document.querySelectorAll('[data-notify-open]').forEach((b) => b.addEventListener('click', nOpen));
    notifyModal.querySelectorAll('[data-notify-close]').forEach((b) => b.addEventListener('click', nClose));
    notifyModal.addEventListener('click', (e) => { if (e.target === notifyModal) nClose(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && notifyModal.classList.contains('is-open')) nClose(); });
    // Form gonderildiyse (basarili) modali otomatik ac -> tesekkur mesaji gorunsun.
    if (notifyModal.querySelector('[data-notify-ok]')) nOpen();
  }

  // --- Taksit Seçenekleri modalı ---
  const taxModal = document.querySelector('[data-tax-modal]');
  if (taxModal) {
    const CUR = taxModal.dataset.currency || 'TRY';
    const money = (cents) => {
      try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: CUR }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2); }
    };
    const sub = taxModal.querySelector('[data-tax-sub]');
    let hideTimer = null;

    // Her banka tablosunu guncel fiyata gore doldur.
    // AKIK metafield'i: data-options = [{ n, rate }] (her taksitin kendi vade farki).
    // Eski bloklar: data-counts + tek data-interest.
    const showSingle = taxModal.dataset.single !== 'false';
    const fill = () => {
      const pdp = document.querySelector('.pdp');
      const price = parseInt((pdp && pdp.dataset.productPrice) || taxModal.dataset.price, 10) || 0;
      if (sub) sub.textContent = money(price) + ' için taksit seçenekleri';
      taxModal.querySelectorAll('[data-tax-bank]').forEach((bank) => {
        let options = [];
        if (bank.dataset.options) {
          try { options = JSON.parse(bank.dataset.options) || []; } catch (e) { options = []; }
        } else {
          const interest = parseFloat(bank.dataset.interest) || 0;
          options = (bank.dataset.counts || '').split(',').map((n) => parseInt(n.trim(), 10)).filter((n) => n > 1).map((n) => ({ n, rate: interest }));
        }
        const rows = bank.querySelector('[data-tax-rows]');
        if (!rows) return;
        let html = showSingle ? `<tr><td>Tek Çekim</td><td>—</td><td class="taxbank__now">${money(price)}</td></tr>` : '';
        html += options.map((o) => {
          const rate = parseFloat(o.rate) || 0;
          const total = Math.round(price * (1 + rate / 100));
          const monthly = Math.round(total / o.n);
          const free = rate > 0 ? '' : ' <small class="taxbank__free">Vade farksız</small>';
          return `<tr><td>${o.n} Taksit${free}</td><td>${money(monthly)}</td><td class="taxbank__now">${money(total)}</td></tr>`;
        }).join('');
        rows.innerHTML = html;
      });
    };

    const open = () => {
      clearTimeout(hideTimer);
      fill();
      taxModal.hidden = false;
      requestAnimationFrame(() => taxModal.classList.add('is-open'));
      document.documentElement.style.overflow = 'hidden';
    };
    const close = () => {
      taxModal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      hideTimer = setTimeout(() => { taxModal.hidden = true; }, 320);
    };
    document.querySelectorAll('[data-tax-open]').forEach((b) => b.addEventListener('click', open));
    taxModal.querySelectorAll('[data-tax-close]').forEach((b) => b.addEventListener('click', close));
    taxModal.addEventListener('click', (e) => { if (e.target === taxModal) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && taxModal.classList.contains('is-open')) close(); });
  }

  // --- Olcu Rehberi modali (yeni sekmeye gitmez) ---
  const sgModal = document.querySelector('[data-sizeguide-modal]');
  if (sgModal) {
    let sgTimer = null;
    const sgOpen = () => {
      clearTimeout(sgTimer);
      sgModal.hidden = false;
      requestAnimationFrame(() => sgModal.classList.add('is-open'));
      document.documentElement.style.overflow = 'hidden';
    };
    const sgClose = () => {
      sgModal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      sgTimer = setTimeout(() => { sgModal.hidden = true; }, 320);
    };
    document.querySelectorAll('[data-sizeguide-open]').forEach((b) => b.addEventListener('click', sgOpen));
    sgModal.querySelectorAll('[data-sizeguide-close]').forEach((b) => b.addEventListener('click', sgClose));
    sgModal.addEventListener('click', (e) => { if (e.target === sgModal) sgClose(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && sgModal.classList.contains('is-open')) sgClose(); });
  }

  // --- Carkli olcu secici (iOS saat secici tarzi): scroll-snap + tik sesi/titresim ---
  (function () {
    var modal = document.querySelector('[data-wheelpick]');
    if (!modal) return;
    var listEl = modal.querySelector('[data-wheel-list]'); // hem kaydirma hem sayilar
    var popEl = modal.querySelector('[data-wheel-pop]');
    var ITEM_H = 42;
    var currentSelect = null, opts = [], lastIdx = -1;

    // Ses kapali (musteri istemedi). Yalniz hafif titresim (destekleyen cihazda).
    var tick = function () {
      try { if (navigator.vibrate) navigator.vibrate(4); } catch (e) {}
    };

    var centerIdx = function () { return Math.max(0, Math.min(opts.length - 1, Math.round(listEl.scrollTop / ITEM_H))); };

    // Kivrimli cark: her sayi, merkezden uzakligina gore KENDI perspektifiyle
    // egilir (perspective() rotateX). Uzakta yatik+soluk, ortada duz+net.
    var ANGLE = 24;   // oge basina egim (derece)
    var applyWheel = function () {
      var centerUnit = listEl.scrollTop / ITEM_H; // ondalik secili index
      var items = listEl.children;
      for (var i = 0; i < items.length; i++) {
        var off = i - centerUnit;          // merkezden uzaklik (oge birimi)
        var a = Math.max(-85, Math.min(85, off * ANGLE));
        var li = items[i];
        li.style.opacity = String(Math.max(0.05, 1 - Math.abs(off) / 3.4));
        li.style.transform = 'perspective(440px) rotateX(' + (-a) + 'deg)';
      }
    };
    var highlight = function () {
      var idx = centerIdx();
      if (idx !== lastIdx) { lastIdx = idx; tick(); }
      var items = listEl.children;
      for (var i = 0; i < items.length; i++) items[i].classList.toggle('is-active', i === idx);
      applyWheel();
    };
    listEl.addEventListener('scroll', function () { window.requestAnimationFrame(highlight); }, { passive: true });

    // Popover'i trigger'in ALTINA konumla (ekran icinde kalacak sekilde).
    var positionPop = function (trigger) {
      var r = trigger.getBoundingClientRect();
      var popW = popEl.offsetWidth || 132;
      var gap = 6, margin = 8;
      // Yatay: trigger'in ortasina hizala, viewport icinde kal.
      var left = r.left + r.width / 2 - popW / 2;
      left = Math.max(margin, Math.min(left, window.innerWidth - popW - margin));
      // Dikey: trigger'in altina; sigmazsa ustune.
      var top = r.bottom + gap;
      var popH = popEl.offsetHeight || 132;
      if (top + popH > window.innerHeight - margin) top = Math.max(margin, r.top - gap - popH);
      popEl.style.left = left + 'px';
      popEl.style.top = top + 'px';
    };

    var open = function (select) {
      currentSelect = select;
      var wrap = select.closest('[data-sizesel]');
      var trigger = wrap && wrap.querySelector('[data-sizesel-trigger]');
      listEl.innerHTML = ''; opts = []; var selIdx = 0;
      for (var i = 0; i < select.options.length; i++) {
        var o = select.options[i];
        var li = document.createElement('li');
        li.className = 'wheelpick__opt' + (o.disabled ? ' wheelpick__opt--disabled' : '');
        li.textContent = o.textContent;
        listEl.appendChild(li);
        opts.push({ value: o.value, disabled: o.disabled });
        if (o.value === select.value) selIdx = i;
      }
      modal.hidden = false;
      if (trigger) positionPop(trigger);
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      lastIdx = selIdx; listEl.scrollTop = selIdx * ITEM_H; highlight();
    };
    // Apple inline davranisi: disariya dokununca ORTADAKI degeri uygular + kapatir.
    var applyAndClose = function () {
      var opt = opts[centerIdx()];
      if (currentSelect && opt && !opt.disabled) {
        currentSelect.value = opt.value;
        currentSelect.dispatchEvent(new Event('change', { bubbles: true }));
        var wrap = currentSelect.closest('[data-sizesel]');
        var cur = wrap && wrap.querySelector('[data-sizesel-cur]');
        if (cur) cur.textContent = opt.value;
      }
      modal.classList.remove('is-open');
      setTimeout(function () { modal.hidden = true; }, 200);
    };

    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-sizesel-trigger]');
      if (t) {
        // Zaten aciksa kapat (toggle); degilse ac.
        if (!modal.hidden) { applyAndClose(); }
        else { var sel = t.closest('[data-sizesel]').querySelector('[data-size-select]'); if (sel) open(sel); }
        return;
      }
      // Popover disina dokunma -> uygula + kapat.
      if (!modal.hidden && !(e.target.closest && e.target.closest('[data-wheel-pop]'))) { applyAndClose(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) applyAndClose(); });
    // Scroll/resize sirasinda acikken kapat (konum kaymasin).
    window.addEventListener('resize', function () { if (!modal.hidden) applyAndClose(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-related]').forEach((el) => {
    const url = el.dataset.url;
    if (!url || el.querySelector('.related__inner')) return;
    fetch(url)
      .then((r) => r.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const fresh = html.querySelector('.related__inner');
        if (fresh) el.innerHTML = fresh.outerHTML;
      })
      .catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    const page = document.querySelector('[data-sp-page]');
    if (!page) return;
    const form = page.querySelector('[data-sp-form]');
    const input = form.querySelector('[data-sp-input]');
    const clear = form.querySelector('[data-sp-clear]');
    const results = page.querySelector('[data-sp-results]');
    const countBox = page.querySelector('[data-sp-count]');
    const SECTION = page.dataset.section;
    let cleanups = [];

    // header.liquid fieldQuery ile ayni bicim (kati eslesme + tam etiket).
    // Esanlamlilar header.liquid'deki window.akikSearchSyn'den (snippets/search-synonyms).
    const synFold = (t) => t.toLocaleLowerCase('tr').replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c');
    const synOf = (t) => {
      const f = synFold(t);
      const g = (window.akikSearchSyn || '').split('|').map((x) => x.split(',').map((v) => v.trim()).filter(Boolean)).find((x) => x.includes(f));
      return g ? [t, ...g.filter((v) => v !== f)] : [t];
    };
    const fieldQuery = (s) => (s || '')
      .replace(/[()"*:]/g, ' ').trim().split(/\s+/)
      .filter((t) => t && !/^(OR|AND|NOT)$/.test(t))
      .map((t) => (/\d/.test(t) ? t + '*' : `(${synOf(t).map((v) => `title:${v}* OR product_type:${v}* OR vendor:${v}* OR tag:${v}`).join(' OR ')})`))
      .join(' ');
    // Sorgudan musterinin yazdigi kelimeler (search.liquid'deki shown_terms ile ayni kural).
    const plainTerms = (q) => (q || '')
      .replace(/\s(or)\s+title:/gi, ' $1 syn:')
      .replace(/[()"]/g, ' ').split(/\s+/)
      .map((t) => {
        t = t.replace(/\*/g, '');
        if (t.includes(':')) { const i = t.indexOf(':'); return t.slice(0, i).toLowerCase() === 'title' ? t.slice(i + 1) : ''; }
        return /^(OR|AND|NOT)$/i.test(t) ? '' : t;
      })
      .filter(Boolean).join(' ');
    // Adres cubugu ve linkler hep sade: /search?q=zultanit+tesbih&type=product&sirala=fiyat-artan
    // (koleksiyon sayfasindaki sirala adlariyla ayni).
    const SORT = { 'price-ascending': 'fiyat-artan', 'price-descending': 'fiyat-azalan', 'created-descending': 'yeni', 'created-ascending': 'eski', 'best-selling': 'cok-satan', 'title-ascending': 'a-z', 'title-descending': 'z-a' };
    const SORT_BACK = Object.fromEntries(Object.entries(SORT).map(([k, v]) => [v, k]));
    const cleanUrl = (url) => {
      const u = new URL(url, location.origin);
      u.searchParams.delete('section_id');
      const q = u.searchParams.get('q');
      if (q != null) u.searchParams.set('q', plainTerms(q));
      const sort = u.searchParams.get('sort_by');
      if (sort) { u.searchParams.delete('sort_by'); if (sort !== 'relevance') u.searchParams.set('sirala', SORT[sort] || sort); }
      return u.pathname + u.search;
    };
    const cleanLinks = () => {
      results.querySelectorAll('a[href*="q="]').forEach((a) => {
        const u = new URL(a.href, location.origin);
        if (u.pathname === location.pathname) a.setAttribute('href', cleanUrl(u.href));
      });
    };
    const urlFor = (v) => (v ? `${form.action}?q=${encodeURIComponent(v).replace(/%20/g, '+')}&type=product` : form.action);

    // --- Sonuc kutusunu yenile (sayfa yeniden yuklenmez, odak kutuda kalir) ---
    let ctrl = null;
    // raw: sorgu oldugu gibi gonderilir (gevsek "en yakin" denemesi); yoksa sade
    // kelimelerden alan onekli sorgu kurulur. Adres cubuguna her durumda sade link yazilir.
    const load = (url, raw) => {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      results.classList.add('is-loading');
      const u = new URL(url, location.origin);
      const plain = plainTerms(u.searchParams.get('q'));
      if (!raw && plain) u.searchParams.set('q', fieldQuery(plain));
      const sirala = u.searchParams.get('sirala');
      if (sirala) { u.searchParams.delete('sirala'); u.searchParams.set('sort_by', SORT_BACK[sirala] || sirala); }
      u.searchParams.set('section_id', SECTION);
      fetch(u.toString(), { signal: ctrl.signal })
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nr = doc.querySelector('[data-sp-results]');
          const nc = doc.querySelector('[data-sp-count]');
          const np = doc.querySelector('[data-sp-page]');
          if (!nr) { location.href = url; return; }
          cleanups.forEach((f) => f()); cleanups = [];
          results.innerHTML = nr.innerHTML;
          results.classList.remove('is-pending');
          if (nc) countBox.innerHTML = nc.innerHTML;
          countBox.hidden = false;
          if (np) page.classList.toggle('search-page--idle', np.classList.contains('search-page--idle'));
          history.replaceState(null, '', cleanUrl(u.href));
          init();
        })
        .catch((e) => { if (e.name !== 'AbortError') location.href = u.href.replace(/[?&]section_id=[^&]*/, ''); })
        .finally(() => results.classList.remove('is-loading'));
    };

    // --- Yazdikca ara (350 ms bekleme, en az 2 harf) ---
    let timer = 0;
    let lastQ = input.value.trim();
    const run = (now) => {
      clearTimeout(timer);
      const v = input.value.trim();
      const fire = () => {
        if (v === lastQ) return;
        if (v && v.length < 2) return;
        lastQ = v;
        load(urlFor(v));
      };
      if (now) fire(); else timer = setTimeout(fire, 350);
    };
    input.addEventListener('input', () => { clear.hidden = !input.value; run(false); });
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (!input.value.trim()) { input.focus(); return; }
      lastQ = '';
      run(true);
      if (window.matchMedia('(hover: none)').matches) input.blur();
    });
    clear.addEventListener('click', () => { input.value = ''; clear.hidden = true; input.focus(); run(true); });
    if (!input.value && window.matchMedia('(hover: hover)').matches) input.focus();

    // Sonuc kutusundaki linkler: populer arama, tur cipleri, siralama -> canli.
    results.addEventListener('click', (e) => {
      const term = e.target.closest('[data-sp-term]');
      if (term) {
        e.preventDefault();
        input.value = term.dataset.spTerm; clear.hidden = false;
        lastQ = ''; run(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      const chip = e.target.closest('a.sp-type');
      if (chip) { e.preventDefault(); load(chip.href); }
    });
    results.addEventListener('change', (e) => {
      if (!e.target.matches('[data-sp-sort]')) return;
      const u = new URL(location.href);
      u.searchParams.delete('sirala');
      u.searchParams.set('sort_by', e.target.value);
      u.searchParams.delete('page');
      load(u.toString());
    });

    // --- Sonuc yoksa: gevsetilmis sorguyla "en yakin sonuclar" ---
    // Shopify aramasi bastan eslesir; tam eslesme olmayinca terimleri OR'layip
    // alfanumerik parcalara ayirarak en yakin urunleri getiririz.
    const initNearest = () => {
      const box = results.querySelector('[data-search-nearest]');
      if (!box) return;
      const q = (box.dataset.q || '').trim();
      // Alan onekli (ad/tip/marka/etiket) sorgu bos dondu: bir kez normal aramaya
      // dus ("Marka Takilar", "Ozel Fiyatlar"). Sonuclar yine search-term-match ile
      // kati suzulur.
      if (box.hasAttribute('data-fielded') && q) {
        const plain = q.split(/\s+/).filter(Boolean).map((t) => t + '*').join(' ');
        load(`${location.pathname}?q=${encodeURIComponent(plain)}&type=product`, true);
        return;
      }
      const grid = box.querySelector('[data-search-nearest-grid]');
      if (!q || !grid) return;

      const terms = q.split(/\s+/).filter(Boolean);
      const wild = (t) => (/[*"]$/.test(t) ? t : t + '*');
      const queries = [];
      // 0) Tum kelimeler, oneksiz: Shopify'in yazim hatasi toleransi ad/tip/marka
      //    uzerinde calisir ("altn" -> Altin, "kolyee" -> Kolye).
      queries.push(terms.map(wild).join(' '));
      // 1) Herhangi bir kelime (OR) — cok kelimeli/yanlis isim aramalari icin.
      if (terms.length > 1) queries.push(terms.map(wild).join(' OR '));
      // 2) Alfanumerik parcalar: "lacj2040017" -> "lacj* OR 2040017*".
      const chunks = [];
      terms.forEach((t) => {
        const parts = t.match(/[a-zA-Z]+|[0-9]+/g);
        if (parts && parts.length > 1) parts.forEach((p) => { if (p.length >= 3) chunks.push(wild(p)); });
      });
      if (chunks.length) queries.push([...new Set(chunks)].join(' OR '));
      // 3) Son care: en uzun tek kelimenin prefix'i.
      const longest = terms.slice().sort((x, y) => y.length - x.length)[0];
      if (longest && longest.length >= 3) queries.push(wild(longest));

      const CUR = box.dataset.currency || 'TRY';
      // Etiket/aciklama yok: yakin sonuclar da yalnizca urun adi/tipi/markasindan.
      const FIELDS = 'title,product_type,variants.title,variants.sku,variants.barcode,vendor';
      const money = (v) => {
        const n = parseFloat(v);
        if (isNaN(n)) return '';
        try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: CUR, maximumFractionDigits: 0 }).format(n); }
        catch (e) { return v; }
      };
      const esc = (x) => String(x == null ? '' : x).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

      const tryNext = (i) => {
        if (i >= queries.length || !box.isConnected) return;
        const url = `/search/suggest.json?q=${encodeURIComponent(queries[i])}`
          + `&resources[type]=product&resources[limit]=12`
          + `&resources[options][unavailable_products]=last`
          + `&resources[options][fields]=${FIELDS}`;
        fetch(url)
          .then((r) => r.json())
          .then((data) => {
            const products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) return tryNext(i + 1);
            grid.innerHTML = products.map((p) => {
              const img = p.featured_image && p.featured_image.url
                ? `<img class="search-card__img" src="${p.featured_image.url}" alt="" loading="lazy">`
                : `<span class="search-card__img search-card__img--empty" aria-hidden="true"></span>`;
              const price = p.price ? `<span class="search-card__price">${money(p.price)}</span>` : '';
              return `<li><a class="search-card" href="${p.url}"><div class="search-card__media">${img}</div>`
                + `<div class="search-card__body"><span class="search-card__title">${esc(p.title)}</span>${price}</div></a></li>`;
            }).join('');
            box.hidden = false;
          })
          .catch(() => tryNext(i + 1));
      };
      tryNext(0);
    };

    // --- Sonsuz kaydirma ---
    const initInfinite = () => {
      results.querySelectorAll('[data-search-infinite]').forEach((inf) => {
        const grid = results.querySelector('.search-page__grid:not([data-search-nearest-grid])');
        if (!grid) return;
        const btn = inf.querySelector('[data-load-more]');
        let loading = false;
        const loadNext = () => {
          const nextUrl = inf.dataset.next;
          if (!nextUrl || loading) return;
          loading = true;
          inf.setAttribute('data-loading', '');
          fetch(nextUrl)
            .then((r) => r.text())
            .then((text) => {
              if (!inf.isConnected) return;
              const doc = new DOMParser().parseFromString(text, 'text/html');
              const newGrid = doc.querySelector('.search-page__grid:not([data-search-nearest-grid])');
              const cards = newGrid ? [...newGrid.children] : [];
              cards.forEach((c) => grid.appendChild(c));
              const newInf = doc.querySelector('[data-search-infinite]');
              if (newInf && newInf.dataset.next && newInf.dataset.next !== nextUrl) {
                inf.dataset.next = newInf.dataset.next;
                loading = false;
                inf.removeAttribute('data-loading');
                // Sentinel hala yakinsa otomatik devam et (kisa sayfa durumu).
                requestAnimationFrame(() => {
                  const r = inf.getBoundingClientRect();
                  if (r.top < window.innerHeight + 700) loadNext();
                });
              } else {
                io.disconnect();
                inf.remove();
              }
            })
            .catch(() => { loading = false; inf.removeAttribute('data-loading'); });
        };
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => { if (e.isIntersecting) loadNext(); });
        }, { rootMargin: '700px 0px' });
        io.observe(inf);
        cleanups.push(() => io.disconnect());
        if (btn) btn.addEventListener('click', loadNext);
      });
    };

    const init = () => { cleanLinks(); initNearest(); initInfinite(); };
    if (results.classList.contains('is-pending')) {
      // Sade linkle gelindi: alan onekli sonuclari getir.
      load(location.href);
    } else {
      // Eski (uzun) linklerle gelindiyse adres cubugunu sadelestir.
      if (/[?&]q=[^&]*(%3A|:)/i.test(location.search) || /[?&]sort_by=/.test(location.search)) history.replaceState(null, '', cleanUrl(location.href));
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-look]').forEach((root) => {
    const dots = [...root.querySelectorAll('[data-look-dot]')];
    const products = [...root.querySelectorAll('[data-look-product]')];
    if (dots.length === 0) return;

    const select = (index) => {
      dots.forEach((d) =>
        d.setAttribute('aria-expanded', d.dataset.lookDot === index ? 'true' : 'false')
      );
      products.forEach((p) => p.classList.toggle('is-active', p.dataset.lookProduct === index));

      // Secilen urun panelde gorunur degilse ona kaydir. Kullanici noktaya
      // basip hicbir sey olmadigini sanmasin.
      const active = products.find((p) => p.dataset.lookProduct === index);
      active?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    };

    dots.forEach((dot) => {
      const index = dot.dataset.lookDot;
      dot.addEventListener('click', () => select(index));
      // Fareyle uzerine gelmek de secer: tiklamadan gezinmek mumkun olsun.
      dot.addEventListener('mouseenter', () => select(index));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-hero"] && !Shopify.designMode) return;
  try {
    
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.split video.split__media-el, .split .split__media-el video').forEach((v) => { v.autoplay = false; v.pause?.(); });
  }

  document.querySelectorAll('[data-split]').forEach((split) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { split.classList.add('is-in'); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        split.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.15 });
    io.observe(split);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-stores]').forEach((root) => {
    const btns = [...root.querySelectorAll('[data-store-btn]')];
    const panels = [...root.querySelectorAll('[data-store-panel]')];
    if (!btns.length) return;
    const activate = (i) => {
      btns.forEach((b) => {
        const on = b.dataset.storeBtn === String(i);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach((p) => {
        const on = p.dataset.storePanel === String(i);
        p.classList.toggle('is-active', on);
        p.hidden = !on;
        // Video: sadece aktif panelde oynasin.
        const v = p.querySelector('video');
        if (v) { if (on) { v.play().catch(() => {}); } else { v.pause(); } }
      });
    };
    btns.forEach((b) => b.addEventListener('click', () => activate(b.dataset.storeBtn)));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticker"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ticker-track]').forEach((track) => {
    const group = track.querySelector('[data-ticker-group]');
    const ticker = track.closest('.ticker');
    if (!group || !ticker) return;

    const build = () => {
      // Onceki kopyalari temizle (yeniden olcum icin ilk gruba don).
      track.querySelectorAll('[data-ticker-clone]').forEach((n) => n.remove());
      // Grubu ilk haline indir: fazladan cogaltilmis ogeleri at.
      const originals = group.dataset.count ? Number(group.dataset.count) : group.children.length;
      if (!group.dataset.count) group.dataset.count = originals;
      while (group.children.length > originals) group.lastElementChild.remove();

      const base = [...group.children].map((n) => n.cloneNode(true));

      // Grup, ekrandan dar kaldigi surece ogeleri tekrarla: tek gecis
      // viewport'u doldurmazsa -50% kayinca sagda bosluk kalir.
      let guard = 0;
      while (group.scrollWidth < ticker.clientWidth && guard < 60) {
        base.forEach((n) => group.appendChild(n.cloneNode(true)));
        guard += 1;
      }

      // Dikissiz dongu icin grubu bir kez daha kopyala: track = [grup][grup].
      const clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-ticker-clone', '');
      clone.removeAttribute('data-ticker-group');
      track.appendChild(clone);

      track.classList.add('is-ready');
    };

    build();

    // Ekran genisligi degisince yeniden kur: yeni genislikte bosluk olusmasin.
    let t;
    window.addEventListener('resize', () => {
      clearTimeout(t);
      t = setTimeout(() => { track.classList.remove('is-ready'); build(); }, 200);
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
